export default {
    "en": {
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "plan_greater_probation": "Plan date greater user probation end date.",
            "you_have_no_assigned_tasks": "You have tasks without assigned date.",
            "path_to_file_corrupt": "Path to file corrupt.",
            "task_without_plan_date": "You have tasks without plan date.",
            "you_have_no_tasks": "Create at least 1 task.",
            "report_settings_required": "Required all fields.",
            "report_company_not_exist": "Company not exist.",
            "report_bad_date_format": "Invalid date format.",
            "can_not_be_competence": "Can not be competence.",
            "can_not_hide_not_competence": "Can not hide not competence.",
            "can_not_remove_not_empty_group": "Can not remove not empty group.",
            "can_not_remove_assigned_competence": "Can not remove assigned competence.",
            "can_not_remove_assigned_skill": "Can not remove assigned skill",
            "can_not_remove_assigned_group": "Can not remove assigned group",
            "can_not_remove_assigned_function": "Can not remove assigned function",
            "can_not_add_skill_to_competence": "Can not add skill to competence.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": [],
            "import": {
                "pernumber_empty": "Employee ID is not specified",
                "pernumber_only_digits": "Employee ID can contain only numbers",
                "pernumber_not_unique": "Employee ID is not unique",
                "surname_not_exists": "Last name of employee is not filled in",
                "firstname_not_exists": "First name of employee is not filled in",
                "invalid_phone": "Invalid phone number format. 11 to 16 numbers are allowed.",
                "not_unique_phone": "Non-unique telephone number",
                "invalid_email": "Invalid format for email",
                "not_unique_email": "Non-unique email",
                "empty_company": "Employee's company is not filled in",
                "not_exist_company": "The system does not have such company",
                "empty_department": "Employee's section is not filled in",
                "not_exist_department": "The system does not have such employee section",
                "empty_position": "Employee's position is not filled in",
                "not_exist_position": "The system does not have  such position",
                "hired_empty": "Start date is not filled in",
                "invalid_date_format_hired": "Wrong start date format. The allowed format is 01/01/2020",
                "invalid_date_format_shift": "Wrong rotation end date format. The allowed format is 01/01/2020",
                "invalid_date_format_period": "Wrong probation end data format. The allowed format is 01/01/2020",
                "save_user_error": "Error in saving the user",
                "not_exist_subdivision": "There is no such department in the system"
            }
        },
        "auth": {
            "login-header": "Log in to the IDP module",
            "remember-me": "Remember me",
            "login": "Log in",
            "logout": "Log out",
            "pernumber": "Employee ID",
            "password": "Password",
            "register": "Register",
            "failed": "Authorization failed.",
            "throttle": "Many authorization attempts. Try again in {seconds}, sec.",
            "token_not_found": "User token is not found."
        },
        "modal": {
            "when_placeholder": "Select dates",
            "provider_placeholder": "Choose a provider",
            "place_placeholder": "Specify the venue",
            "duration_placeholder": "Enter duration in hours",
            "link_placeholder": "Insert link",
            "comment_placeholder": "Enter a comment",
            "description_placeholder": "Enter a description",
            "attached_by_you": "Attached by you",
            "attached_by_hr": "Attached by HR",
            "attached_by_manager": "Attached by manager",
            "attached_by_employee": "Attached by employee",
            "created_by_you": "Added by you",
            "created_by_hr": "Added by HR",
            "created_by_manager": "Added by manager",
            "created_by_fmanager": "Created by func. manager",
            "created_by_employee": "Added by employee",
            "delete": "Delete",
            "delete_question": "Do you want to delete a file?",
            "delete_employee_question": "Do you want to delete an account?",
            "delete_hr_link_question": "Do you want to remove the HR binding?",
            "delete_manager_link_question": "Do you want to remove the manager binding?",
            "delete_fmanager_link_question": "Do you want to delete the account?",
            "cancel": "Cancellation",
            "files_input_placeholder": "Click and select a file on your device or drag and drop it here",
            "drop_placeholder": "Drag the file here",
            "big_file_error": "The file you tried to upload is larger than 10 MB. Check and upload a valid file size.",
            "show_only_necessary_fields": "Show only necessary fields",
            "add_training": "Adding a training",
            "add_training_description_1": "The educational activity you have chosen",
            "add_training_description_2": "is in a training format. This means that it will be added to your list of \"Requests\" and must be approved by your HR. Do you still want to add it?",
            "add": "Add",
            "manager": "Manager",
            "fmanager": "Func. manager",
            "employee": "Employee",
            "idp_export": "Configuration of the IDP report",
            "wish_export": "Configuration of the report on requests ",
            "training_export": "Configuration of the report on training days",
            "idp_export_download": "Generate a report",
            "idp_export_year": "Select period",
            "idp_export_tab_type": "Select tabs",
            "idp_export_row": "Select fields",
            "idp_export_wish": "Requests",
            "idp_export_learning": "Training",
            "idp_export_pernumber": "ID",
            "idp_export_fio": "Full name",
            "idp_export_position": "Position",
            "idp_export_employee_type": "Employee type",
            "idp_export_reservist": "Talent pool member",
            "idp_export_employee_group": "Employee group",
            "idp_export_sex": "Sex",
            "idp_export_bu": "Business unit",
            "idp_export_department": "Department",
            "idp_export_division": "Division",
            "idp_export_subdivision": "Section",
            "idp_export_org_5": "Org. structure: 5 level",
            "idp_export_org_6": "Org. structure: 6 level",
            "idp_export_org_7": "Org. structure: 7 level",
            "idp_export_org_8": "Org. structure: 8 level",
            "idp_export_employee_status": "Employee status",
            "idp_export_supervisor": "Line manager",
            "idp_export_idp_year": "IDP year",
            "idp_export_idp_status": "IDP status",
            "idp_export_idp_percent": "IDP completion percentage",
            "idp_export_learning_group": "Training group",
            "idp_export_function": "Function / position",
            "idp_export_competencies": "Groups of competencies / groups of skills",
            "idp_export_skills": "Competencies / skills",
            "idp_export_format": "Format",
            "idp_export_type": "Type",
            "idp_export_resource": "Resource",
            "idp_export_method": "Method",
            "idp_export_event_name": "Activity name",
            "idp_export_provider": "Provider",
            "idp_export_trainer": "Trainer's/mentor’s name",
            "idp_export_duration": "Duration, h",
            "idp_export_course_description": "Course description",
            "idp_export_target_group": "Target group",
            "idp_export_program": "Program",
            "idp_export_learning_materials": "Training materials",
            "idp_export_period": "Training period",
            "idp_export_status": "Status",
            "idp_export_all_hours": "Total hours",
            "idp_export_all_days": "Total days",
            "idp_export_all_trainings": "Total trainings",
            "idp_export_training_employees": "Training days (Employees)",
            "idp_export_training_result": "Training days (Total)",
            "idp_export_training_name": "Training title",
            "idp_export_training_type": "Type",
            "idp_export_training_all_hours": "Total number of hours in training",
            "idp_export_training_days": "Training days",
            "idp_export_training_hours_in_day": "Number of training hours per day",
            "idp_export_training_assign_employees": "Number of employees who were assigned the training",
            "idp_export_training_success_employees": "Number of employees who completed the training",
            "idp_export_training_percent_employees": "Percentage of employees who completed the training",
            "idp_export_hours_result": "Hours total",
            "idp_mandatory_export": "Configuration of the report on mandatory training",
            "idp_status_export": "Configuration of the Report: IDP status",
            "idp_export_event_divide": "Course category",
            "idp_export_finish_date": "Date of completion",
            "idp_export_mandatory_learning": "Mandatory training",
            "idp_export_fired_status": "Status",
            "idp_export_fired_status_active": "active",
            "idp_export_fired_status_fired": "fired",
            "idp_export_without_fired": "excluding fired",
            "idp_export_category": "Category",
            "idp_export_module": "Module",
            "required_field": "required field",
            "only_for_workers": "only for frontline",
            "report_generating": "The report is being generated",
            "successfully_assigned": "successfully assigned to selected employees",
            "successfully_added": "The training has been successfully added to the IDP",
            "already_been_added": "The training has already been added to the IDP",
            "to_the_catalog": "To the catalog",
            "next": "Next",
            "select_all": "Select all"
        },
        "voc": {
            "download_form": "Form",
            "recruitment_date": "Start date",
            "transferred_to_another_position": "Transferred to another position",
            "end_of_probation": "End of probation period",
            "working": "Works",
            "not_working_yet": "Before work",
            "managers": "Managers",
            "managers_empty": "No information about managers",
            "manager": "Manager",
            "functional_managers": "Functional managers",
            "functional_managers_empty": "No information about functional managers",
            "functional_manager": "Functional manager",
            "mentor": "Mentor",
            "choose_you_destiny": "Choose an employee from the list",
            "not_selected": "Not chosen",
            "mentor_not_required": "Mentor is optional",
            "newbie_coming_in_3_days": "New employee start date",
            "table_pernumber": "ID",
            "table_fullname": "Full Name",
            "table_position": "Position",
            "table_status_idp": "IDP status",
            "table_date_come": "Start date",
            "table_status": "Status",
            "table_format": "Format",
            "table_deadline": "Time",
            "table_close_sidebar": "Hide list of employees",
            "table_close_sidebar_employee": "Hide",
            "table_open_sidebar": "Show list of employees",
            "table_open_sidebar_employee": "Show personal data and information about managers",
            "table_author": "Author",
            "table_series": "Series and number",
            "table_type": "Type",
            "table_reservist": "Talent pool member",
            "table_group": "Group",
            "table_level": "Level",
            "table_name": "Activity name",
            "table_subdivision": "Subdivision",
            "table_status_activity": "Status activity",
            "report_idp": "Report on IDP",
            "report_mandatory_learning": "Report on mandatory training",
            "report_training_days_employees": "Report on training days (Employees)",
            "report_training_days_trainings": "Report on training days (Trainings)",
            "report_wishes": "Report on requests",
            "newbie_no_tasks_after_8_days": "Probation period task setting",
            "newbie_no_verified_tasks_before_7_days": "Decision on probation period ",
            "probation_period_is": "Consider probation period to be",
            "waiting_probation_period_decision": "Decision is pending",
            "succeed_probation_period_decision": "Successful",
            "no_assigned_managers": "No managers",
            "end_of_shift": "End of the 1st rotation",
            "yes": "Yes",
            "no": "No",
            "all": "All",
            "add_mentor_modal_title": "Employee's mentor",
            "mentor_field": "Mentor",
            "mentor_field_default": "Choose mentor from the list",
            "mentor_add_button": "Appoint",
            "mentor_reset_button": "Delete",
            "delete_mentor_error": "Error in deleting mentor. Contact the support service.",
            "mentor_field_can_edit": "Can manage tasks",
            "mentor_not_from_same_department": "Mentor must be from the same department",
            "mentor_not_from_same_company": "Mentor must be from the same company",
            "mentor_and_newbie_same_user": "Mentor and employee cannot be same person",
            "add_mentor_error": "Error in adding mentor",
            "error": "Error",
            "welcome_home_link": "Main",
            "relations": "Connections",
            "mentor_assigned": "Appointment as a mentor",
            "no_shift_end": "Not defined",
            "no_feature_for_role": "Sorry, but there is no functionality for your role",
            "no_copy_tasks": "There are no previously created tasks for this position.",
            "newbie_no_certificate": "Certificate loading function is not available.",
            "probation_period_success": "Probation is successful!",
            "congrats": "Congratulations and we wish you productive work at Nordgold",
            "download_certificate": "Download certificate",
            "shift_at": "End of the 1st rotation",
            "your_probe_period_is_end": "Your probation period has been successfully completed.",
            "you_have_not_newbies": "You have no employees on probation period.",
            "control_probation_period_report": "Probation period from %s to %s",
            "group_subdivision": "Employee division",
            "company": "Company",
            "employee_probation_period_status": "Status",
            "employee_probation_period_status_process": "in process",
            "employee_probation_period_status_passed": "passed",
            "employee_probation_period_status_not_passed": "failed",
            "employees": "Employees",
            "catalog": "Catalogue",
            "idp": "IDP",
            "my_idp": "My IDP",
            "employee_idp": "Employee IDP",
            "academy_nordgold": "Nordgold Academy",
            "date_create_task": "Tasks setting date",
            "date_evaluate_task": "Tasks evaluation date",
            "date_dismissal": " Termination date",
            "choose_all_companies": "All BU",
            "choose_all_departments": "All departments",
            "mentor_field_filter": "Filter",
            "mentor_field_filter_button": "Search",
            "mentor_field_filter_placeholder": "Employee ID, Surname, Name, Position",
            "short_tab_number": "Emp ID",
            "choose_mentor_from_dropdown_list": "Select mentor from dropdown list",
            "russian": "Russian",
            "english": "English",
            "french": "French",
            "save": "Save",
            "assign": "Assign",
            "skip": "Skip",
            "from": "from",
            "to": "to",
            "at": "at",
            "today": "today",
            "yesterday": "yesterday",
            "view_individual_education": "View individual learning",
            "view_common_education": "View learning",
            "view_wish": "View wish",
            "view_event": "View learning",
            "edit_individual_education": "Edit individual learning",
            "edit_common_education": "Edit learning",
            "edit_wish": "Edit wish",
            "edit_event": "Edit activity",
            "create_individual_education": "Create individual learning",
            "create_event": "Create activity",
            "copy_event": "Event duplication",
            "create_wish": "Create wish",
            "create_deadline": "Set a deadline",
            "create_new_deadline": "Create new deadline",
            "is_hidden": "Hidden",
            "delete": "Delete",
            "actions": "Actions",
            "warning_actions_employee": "Select employees from the list to see available actions",
            "warning_actions_activity": "Select training in the table to see the available actions",
            "warning_wishes_activity": "To see the available actions, select the request in the table",
            "loading": "Loading...",
            "table_event_name": "Name of training",
            "table_direction": "Direction",
            "table_company": "Company",
            "table_periodicity": "Frequency",
            "male": "Male",
            "female": "Female",
            "system_message": "System message",
            "dated": "dated",
            "valid_until": "valid until",
            "indefinitely": "indefinitely",
            "active": "Active",
            "fired": "Fired",
            "trainings": "Trainings",
            "author_assignment": "The author of the assignment",
            "last_edit": "Last edit",
            "learning_Matrix": "The Learning Matrix",
            "system": "System",
            "queue": "Queue",
            "out_of": "out of",
            "generate_report_error": "The report could not be generated, select a smaller data slice",
            "no_processes": "There are no processes"
        },
        "admin": {
            "new_emp": "New employee",
            "new_hr": "New HR",
            "new_mentor": "New mentor",
            "new_manager": "New manager",
            "new_functional_manager": "New functional manager",
            "import": "Import",
            "manual": "Manually",
            "batch": "Package",
            "export": "Export",
            "log_history": "Log history",
            "tab_number": "Employee ID",
            "employee": "Employee",
            "employees": "Employees",
            "company": "Company",
            "business_item": "Business unit",
            "companies": "Companies",
            "no_companies_users": "Users not found",
            "department": "Department",
            "org_5": "Org. structure: 5 level",
            "position": "Position",
            "fired_at": "Fired At",
            "phone": "Phone",
            "in_system": "On probation period",
            "in_white_list": "On the whitelist",
            "source": "Source",
            "employee_add": "Adding a new employee",
            "pernumber": "Employee ID",
            "novice": "Yes",
            "not_novice": "No",
            "roles": "Roles",
            "email": "Email",
            "division": "Section",
            "subdivision": "Department",
            "no_division": "Not specified",
            "shift_at": "Shift end at",
            "mentor_can_edit": "Mentor's expanded rights",
            "without_probation": "No probation period",
            "user_not_found": "Employee is not found.",
            "employee_imported": "Employees are imported successfully.",
            "notify_button": "Alerts",
            "config_notification_title": "Employee selection",
            "save_settings": "Save",
            "notification_settings_updated": "Notification settings updated",
            "notification_settings_failed_updated": "The BU alert settings have not been updated.",
            "add_provider": "Add a provider",
            "provider": "Provider",
            "russian": "Russian",
            "english": "English",
            "french": "French",
            "providers": "Providers",
            "provider_add_error": "An error occured while creating a provider",
            "provider_edit_error": "An error occured while changing a provider",
            "provider_add_success": "Provider added successfully",
            "provider_edit_success": "Provider changed successfully",
            "provider_delete_success": "Provider has been successfully deleted",
            "can_edit_catalog": "Can work with catalog",
            "report_button": "Report",
            "competences": "Groups of competencies / groups of skills",
            "rename": "Rename",
            "delete": "Delete",
            "hide": "Make inactive",
            "show": "Make active",
            "matrix": "Matrix",
            "be": "BE",
            "fio": "FIO",
            "reservist": "Reservist",
            "group": "Group",
            "level": "Level",
            "connections": "Connections",
            "chapter": "Chapter",
            "employee_data": "Employee data",
            "create_employee": "New employee",
            "create_hr": "New HR",
            "create_manager": "New manager",
            "create_func_manager": "New func. manager",
            "add_group": "New group",
            "add_function": "Add a function / position",
            "add_competence": "Add a group of competencies / group of skills",
            "add_skill": "Add a competency / skill",
            "rename_group": "Rename the group",
            "rename_function": "Rename the function / position",
            "rename_competence": "Rename the group of competencies / group of skills",
            "rename_skill": "Rename the competency / skill",
            "rename_provider": "Rename the provider",
            "delete_provider_question": "Do you want to delete the provider?",
            "new_provider": "New provider",
            "not_delete": "You can delete an account that is on the whitelist",
            "add_matrix_activity": "Add training to the matrix",
            "import_matrix": "Import",
            "export_matrix": "Export",
            "make_active": "Make active",
            "make_not_active": "Make inactive",
            "main_qualification": "Qualification (main)",
            "optional_qualification": "Qualification (optional)",
            "pbiot": "PBiOT",
            "first_aid": "First aid",
            "ecology": "Ecology",
            "gnvp": "GNVP",
            "professional": "Professional",
            "one_time": "1 time",
            "one_time_in_year": "1 time in year",
            "one_time_in_two_years": "1 time in 2 years",
            "one_time_in_three_years": "1 time in 3 years",
            "one_time_in_five_years": "1 time in 5 years",
            "one_time_in_ten_years": "1 time in 10 years",
            "active": "Active",
            "not_active": "Not active",
            "mandatory": "Mandatory",
            "additional": "Additional",
            "certificate": "Certificate",
            "qualification_certificate": "Qualification certificate",
            "protocol": "Protocol",
            "protocol_identity": "Protocol / identity",
            "create_matrix": "Add mandatory training",
            "edit_matrix": "Editing mandatory training",
            "direction": "Direction",
            "priority": "Priority",
            "documents": "Documents",
            "periodicity": "Frequency",
            "activity_link": "Link to training in the \"Catalog\"",
            "matrix_import_error": "The learning matrix cannot be imported \nbecause one or more of the fields \ndoes not match the specified format. \nCheck the file and upload the correct version again.",
            "matrix_activity_already_exists": "Matrix activity already exists",
            "all_departments": "All departments"
        },
        "role": {
            "admin": "Administrator",
            "manager": "Manager",
            "managers": "Managers",
            "fmanager": "Functional manager",
            "fmanagers": "Functional managers",
            "employee": "Employee",
            "employees": "Employees",
            "mentor": "Mentor",
            "hr": "HR",
            "newbie": "New employee"
        },
        "idp": {
            "search_placeholder": "Find employees",
            "employee_list": "List of employees",
            "star_tooltip": "This employee is on the list of <br> reservists and is eligible for a <br> promotion in the near future",
            "fires_tooltip": "fired",
            "employees": "Employees",
            "men": "persons | person | persons | persons",
            "download": "Download",
            "download_report": "Download report",
            "individual_development_plan": "Individual development plan",
            "not_formed": "Not formed",
            "on_approval": "Approval pending",
            "on_approval_employee_list": "To be approved",
            "agreed_by_manager": "Approved by manager",
            "agreed_by_hr": "Approved by HR",
            "agreed_by_hr_employee_list": "Approved",
            "for": "for",
            "send_to_approve_idp": "Submit for approval",
            "assign_idp": "Approve IDP",
            "assign_wish": "Approve requests",
            "assign_all_wishes": "Approve all requests",
            "assign_not_assigned": "Assign uncoordinated learning",
            "add_learning_from_catalog": "Add training from catalog",
            "mark_learning_as_complete": "Mark learning as complete",
            "change_learning_status": "Change training status",
            "load_files": "Upload files",
            "all_years": "All years",
            "yr": "г.",
            "filter_event_by_status": "Status filter",
            "competencies": "Groups of competencies / groups of skills",
            "when": "When",
            "type": "Type",
            "add": "Add training",
            "assign": "Assign",
            "complete": "Complete",
            "pending": "Approval pending",
            "approved": "Approved by HR",
            "assigned": "Assigned",
            "inprogress": "In Progress",
            "assigned_for_wish": "Approved",
            "rejected": "Declined",
            "canceled": "Cancelled",
            "canceled_wish": "Postponed",
            "available": "Available in Academy",
            "done": "Completed",
            "notdone": "Not completed",
            "expired": "Expired",
            "mandatory": "Mandatory",
            "addition": "Additional",
            "additional": "Additional",
            "mandatory_security": "Safety Commitment",
            "learnings": "Training that is assigned to the employee",
            "learnings_employee": "The training you have been assigned",
            "wishes_txt": "Employee’s training requests",
            "wishes_txt_employee": "Your requests for training",
            "mandatory_tooltip": "This block contains mandatory events that HR adds. You can also add events from the catalog or create them yourself in agreement with HR or the manager.",
            "additional_tooltip": "This block contains <b><u>optional</u></b> for completing the event that HR adds. You can also add events from the catalog or create them yourself in agreement with HR or the manager.",
            "mandatory_security_tooltip": "Events, courses and other developmental activities that are necessary to comply with occupational safety requirements.",
            "wishes_tooltip": "Other non-priority individual recommendations that the employee may receive in addition to basic developmental activities.",
            "assign_not_assigned_help": "The child status you selected is automatically set for all <br> inconsistent training in the \"Draft\" status",
            "learning_tooltip": "Activities, courses and other developmental activities that are required as a priority to achieve the goals set, develop and/or strengthen key professional and personal skills.",
            "status_tooltip": "Instructions on IDP approval are available for downloading in PDF format at the following <a href=\"/\" target=\"_blank\"><b><u>link</u></b> </a> <br> In order to approve the IDP it is necessary to approve or reject all the requests added by the employee",
            "assign_wishes_help": "The status you have chosen will be automatically set for all wishes in the “Pending” status. <br>Attention! All requests for trainings from the Catalog will be added to the “Training that has been added to the employee” block with the “Assigned” status.",
            "wish_tooltip": "The agreed wishes are transferred to the role. In accordance with them, training will be added to the catalog or to the employees IDP.",
            "catalog": "Catalog IDP",
            "course": "Course in NG Academy",
            "event": "Activities in NG Academy",
            "external": "Outside the platform",
            "individual": "Individual",
            "wishes": "Employee wish",
            "matrix": "Learning matrix",
            "others": "Others",
            "not_found_mandatory": "Learning has not been added yet. Check the filter by status",
            "not_found_mandatory_security": "Security commitments not yet added or do not match status filters",
            "not_found_addition": "Learning has not been added yet. Check the filter by status",
            "not_found_wishes": "Wishes not yet added or do not match status filters",
            "f_of": "Full-time",
            "f_or": "Remote",
            "f_oroli": "Remote (OLIMPOKS)",
            "f_ofr": "Full-time / remote",
            "m_ow": "On-the-job",
            "create_individual": "Create individual",
            "create": "Create",
            "checkout": "Create",
            "create_wish": "Make a request",
            "add_from_catalog": "Choose from catalog",
            "cm_view": "View",
            "cm_view_edit": "View / edit",
            "cm_comment": "leave a comment",
            "cm_reject": "Reject",
            "cm_assign": "Approve",
            "cm_delete": "Delete",
            "cm_duplicate": "Duplicate",
            "cm_move_to_mandatory": "To the mandatory",
            "cm_move_to_additional": "To the additional",
            "cm_move_to_mandatory_security": "To the mandatory for security",
            "cm_attach_files": "Attach files",
            "cm_mark_as_done": "Mark as done",
            "cm_attach_new_files": "Attach new files",
            "cm_set_new_deadline": "Set a new time",
            "cm_cancel": "Cancel",
            "cm_cancel_wish": "Cancel",
            "cm_assign_hr": "Assign",
            "cm_approve": "Approve",
            "cm_mark_as_in_process": "Mark ass “In process”",
            "cm_mark_as_not_done": "Mark as not done",
            "comment": "comments | comment | comment | comments",
            "file": "files | file | file | files",
            "write_comment": "Leave a comment",
            "has_expired_activities": "There is expired training",
            "has_inconsistent_activities": "Has inconsistent activities",
            "has_new_wishes": "There are new requests",
            "till": "till",
            "employee": "Employee",
            "hr": "HR",
            "manager": "Manager",
            "format_at_workplace": "On-the-job",
            "format_interaction": "Interaction",
            "format_training": "Training",
            "type_in_person": "Offline",
            "type_online": "Online",
            "type_mix": "Mixed",
            "resource_external": "External",
            "resource_internal": "Internal",
            "method_mentorship": "Mentorship",
            "method_coaching": "Coaching",
            "method_internship": "Internship",
            "method_self_improvement": "Self-development",
            "method_participation": "Participation in projects",
            "added_by_you": "Added by you",
            "target_group_hr": "Managers",
            "target_group_specialists": "Specialists",
            "target_group_workers": "Frontline",
            "change_learning_statuses": "Change training statuses",
            "change_learning_status_help": "You can change training statuses only in approved IDPs for those trainings that do not take place on external platforms (Nordgold Academy). <br><br>Please note that individual training must be approved individually for each employee!",
            "select_learning_activity": "Select training from the list below",
            "display_only_with_assigned_learning": "The list of employees displays only those for whom this training was added to the IPR, as well as the status of this training. Choose the one you want to install. Some statuses may not be available.",
            "attach_files_help": "In this window you can upload files (e.g. certificates of completion) for all employees whose training has been added to the IDP in any status. <br>This option is only available for training that is added from the catalog.",
            "display_all_status_learning": "The list of employees displays only those for whom this training was added to the IPR in any status.",
            "select_for_all": "Select for all",
            "empty_wish_list": "Requests have not yet been added or do not fit the filters set",
            "empty_learnings_list": "No assignments for the selected period or selected filters",
            "learning_for": "Learning for",
            "y": "y.",
            "you": "You",
            "not_found_assignments": "No assignments for the selected period or selected filters",
            "per_page": "per page"
        },
        "catalog": {
            "add_to_idp": "Add to IDP",
            "dont_you_found": "Did you not find a program or activity?",
            "you_can_create_new": "Make a request or create an individual training in your IDP",
            "create_event": "Create activity",
            "view_event": "View event",
            "edit_event": "Edit activity",
            "import_from_excel": "Import from Excel",
            "assign": "Add to IDP",
            "if_not_found_create_new": "Can't find a program or event?<br>Create a wish or an individual task",
            "assign_as": "how",
            "was_assign_for": "For ",
            "events_and_programs": "programs / activities or requests",
            "was_assign_users": " employees have already been assigned",
            "assign_search_group": "Find group",
            "assign_need_activity": "At least one position must be selected",
            "was_assign_show_users": "View Employees",
            "was_assign_assignments": "View appointments",
            "assigned_activities": "Events and programs have already been scheduled",
            "assignment_title": "In employees' IDP:",
            "code": "Code",
            "name": "Activity name",
            "competencies": "Group of competencies / group of skills",
            "source": "Source",
            "competence": "Group of competencies / group of skills",
            "skills": "Competencies / skills",
            "all": "All",
            "format": "Format",
            "format_at_workplace": "On-the-job",
            "format_webinar": "Online course / webinar",
            "format_offline": "Training / offline program",
            "method_at_workplace": "On-the-job",
            "method_internal_training_by_trainer": "Internal training by BU trainer (at BU)",
            "method_internal_training_by_external_trainer": "Internal training by an external trainer (on BU)",
            "method_external_group": "External group training (not on BU)",
            "method_external_individual": "External individual training (not on BU)",
            "method_probation": "Internship at other Nordgold enterprises",
            "method_webinar": "Online course / webinar",
            "author": "Author",
            "group": "Group",
            "function": "Function / position",
            "type": "Type",
            "resource": "Resource",
            "method": "Method",
            "trainer_fio": "Trainer's/mentor’s name",
            "duration": "Duration, h",
            "provider": "Provider",
            "target_group": "Target group",
            "competence_skill": "Competencies / skills",
            "program": "Program",
            "educational_materials": "Training materials",
            "category": "Category",
            "employee": "Staff",
            "when": "Deadline",
            "mass_deadline_for_all": "Set a deadline for everyone at once",
            "mass_deadline_for_one": "Set a deadline",
            "mass_deadline_for_every": "Or set a deadline for each employee individually",
            "set_new_deadline": "Set a new deadline",
            "period": "Period",
            "comment": "Comment",
            "link": "Link",
            "link_edit": "Link (if there is)",
            "description": "Course description",
            "search_any_way": "Search all over",
            "view": "View",
            "cm_view": "View",
            "view_edit": "View / Edit ",
            "edit": "Edit",
            "assign_to_employees": "Assign to employees",
            "add_as_mandatory": "Add to IDP as mandatory",
            "add_as_additional": "Add to IPR as an additional",
            "add_as_security_commitment": "Add to IPR as a Security Commitment",
            "view_assignment": "See the assignments",
            "not_fully_valid": "All required fields are <br> not filled in the card",
            "mass_period": "Change the period",
            "set_new_period": "Set the period",
            "common_for_all": "Common to all trainings",
            "name_placeholder": "Enter the name",
            "add_competence": "Add a group of competencies / group of skills",
            "add_another_competence": "Add another group of competencies / group of skills",
            "what_to_do": "What should be done",
            "how_to_develop": "How do I develop it?",
            "priority": "Priority",
            "additional_info": "Additional Information",
            "additional_info_helper": "Specify the provider, the link to the event or other important information",
            "clear_competence": "Delete",
            "add_skill": "Add a competency / skill",
            "add_another_skill": "+Add another competency / skill",
            "add_another_files": "+Add more files",
            "choose_competence": "Choose a competency",
            "choose_format_method": "Choose format",
            "choose_skill": "Choose a competency / skill",
            "course": "Course at NG Academy",
            "event": "Event at NG Academy",
            "external": "Off platform",
            "wishes": "Wishes",
            "start_typing_for_search": "Start typing to search",
            "no_result_name": "No results for",
            "template": "Template",
            "create_template": "Create Template",
            "edit_template": "Edit Template",
            "template_name": "Template name",
            "add_event": "Add event",
            "event_placeholder": "Choose a program or event",
            "selected_event": "Selected events",
            "hide_expired": "Hide expired",
            "hide_inactive": "Hide inactive",
            "learning": "Learning \"",
            "learning_already_exists": "\" has already been added to your IDP",
            "learning_already_exists_in_employee": "\" has already been added to employee IDP",
            "go_to_my_idp": "Go to my IDP",
            "go_to_employee_idp": "Go to employee IDP",
            "mass_assign_alert_1": "Training",
            "mass_assign_alert_2": "has already been assigned to employees you selected",
            "available_by": "available via",
            "ekvio_link": "link",
            "employee_type_specialist_manager": "Specialist-manager",
            "employee_type_common_employee": "Common employee"
        }
    },
    "fr": {
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "plan_greater_probation": "Plan date greater user probation end date.",
            "you_have_no_assigned_tasks": "You have tasks without assigned date.",
            "path_to_file_corrupt": "Path to file corrupt.",
            "task_without_plan_date": "You have tasks without plan date.",
            "you_have_no_tasks": "Create at least 1 task.",
            "report_settings_required": "Required all fields.",
            "report_company_not_exist": "Company not exist.",
            "report_bad_date_format": "Invalid date format.",
            "can_not_be_competence": "Can not be competence.",
            "can_not_hide_not_competence": "Can not hide not competence.",
            "can_not_remove_not_empty_group": "Can not remove not empty group.",
            "can_not_remove_assigned_competence": "Can not remove assigned competence.",
            "can_not_remove_assigned_skill": "Can not remove assigned skill",
            "can_not_remove_assigned_group": "Can not remove assigned group",
            "can_not_remove_assigned_function": "Can not remove assigned function",
            "can_not_add_skill_to_competence": "Can not add skill to competence.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": [],
            "import": {
                "pernumber_empty": "Numéro matricule n’est pas indiqué",
                "pernumber_only_digits": "Numéro matricule ne peut contenir que des chiffres",
                "pernumber_not_unique": "Numéro matricule non unique",
                "surname_not_exists": "Nom de salarié n'est pas rempli",
                "firstname_not_exists": "Prénom de salarié n'est pas rempli",
                "invalid_phone": "Format erroné du numéro de téléphone. De 11 à 16 symboles numéraux sont admis",
                "not_unique_phone": "Numéro de téléphone non unique",
                "invalid_email": "Format erroné de l’adresse email",
                "not_unique_email": "Adresse email non unique",
                "empty_company": "Société de salarié n'est pas remplie",
                "not_exist_company": "Cette société n’existe pas au système ",
                "empty_department": "Rubrique de salarié n'est pas remplie",
                "not_exist_department": "Cette position de salarié n’existe pas au système ",
                "empty_position": "Fonction de salarié n'est pas remplie",
                "not_exist_position": "Cette fonction n’existe pas au système",
                "hired_empty": "Date d’embauche n’est pas remplie",
                "invalid_date_format_hired": "Format erroné de la date d’embauche. Le format 01/01/2020 est admis",
                "invalid_date_format_shift": "Format erroné de la date de fin du poste. Le format 01/01/2020 est admis",
                "invalid_date_format_period": "Format erroné de la date d’expiration de la période d’essai. Le format 01/01/2020 est admis",
                "save_user_error": "Erreur lors de l’enregistrement de l’utilisateur",
                "not_exist_subdivision": "Cette section n’existe pas au système"
            }
        },
        "auth": {
            "login-header": "Log in to the IDP module",
            "remember-me": "Remember me",
            "login": "Entrer",
            "logout": "Se déconnecter",
            "pernumber": "Numéro matricule",
            "password": "Mot de passe",
            "register": "S’inscrire",
            "failed": "Echec d’autorisation.",
            "throttle": "Beaucoup de demandes d’autorisation. Veuillez réessayer dans: seconds s.",
            "token_not_found": "Token de l’utilisateur n’a pas été retrouvé"
        },
        "modal": {
            "when_placeholder": "Select dates",
            "provider_placeholder": "Choose a provider",
            "place_placeholder": "Specify the venue",
            "duration_placeholder": "Enter duration in hours",
            "link_placeholder": "Insert link",
            "comment_placeholder": "Enter a comment",
            "description_placeholder": "Enter a description",
            "attached_by_you": "Attached by you",
            "attached_by_hr": "Attached by HR",
            "attached_by_manager": "Attached by manager",
            "attached_by_employee": "Attached by employee",
            "created_by_you": "Ajouté par vous",
            "created_by_hr": "Ajouté par RH",
            "created_by_manager": "Ajouté par le responsable",
            "created_by_fmanager": "Created by func. manager",
            "created_by_employee": "Ajouté par un employé",
            "delete": "Supprimer",
            "delete_question": "Do you want to delete a file?",
            "delete_employee_question": "Do you want to delete an account?",
            "delete_hr_link_question": "Do you want to remove the HR binding?",
            "delete_manager_link_question": "Do you want to remove the manager binding?",
            "delete_fmanager_link_question": "Voulez-vous supprimer le compte ?",
            "cancel": "Annulation",
            "files_input_placeholder": "Cliquez et sélectionnez un fichier sur le dispositif ou faites-le glisser ici",
            "drop_placeholder": "Drag the file here",
            "big_file_error": "The file you tried to upload is larger than 10 MB. Check and upload a valid file size.",
            "show_only_necessary_fields": "Afficher uniquement les champs obligatoires",
            "add_training": "Adding a training",
            "add_training_description_1": "L'activité que vous avez choisie",
            "add_training_description_2": "est au format de formation. Cela signifie qu'elle sera ajoutée à la liste de \"Demandes\" et doit être approuvée par votre RH. Voulez-vous toujours l'ajouter ?",
            "add": "Add",
            "manager": "Responsable",
            "fmanager": "Responsable fonctionnel",
            "employee": "Employé",
            "idp_export": "Configuration du rapport PDI",
            "wish_export": "Configuration d'un rapport sur les souhaits",
            "training_export": "Configuration d'un rapport sur les journées de formation",
            "idp_export_download": "Générer un rapport",
            "idp_export_year": "Sélectionnez une période",
            "idp_export_tab_type": "Sélectionnez des onglets",
            "idp_export_row": "Sélectionnez les champs",
            "idp_export_wish": "Souhaits",
            "idp_export_learning": "Formation",
            "idp_export_pernumber": "Numéro d'identification",
            "idp_export_fio": "Nom complet",
            "idp_export_position": "Poste",
            "idp_export_employee_type": "Type d'employé",
            "idp_export_reservist": "Réserviste",
            "idp_export_employee_group": "Groupe d'employé",
            "idp_export_sex": "Sexe",
            "idp_export_bu": "Unité commerciale",
            "idp_export_department": "Département",
            "idp_export_division": "Division",
            "idp_export_subdivision": "Section",
            "idp_export_org_5": "Structure organisationnelle : niveau 5",
            "idp_export_org_6": "Structure organisationnelle : niveau 6",
            "idp_export_org_7": "Structure organisationnelle : niveau 7",
            "idp_export_org_8": "Structure organisationnelle : niveau 8",
            "idp_export_supervisor": "Chef hiérarchique",
            "idp_export_idp_year": "Année du PDI",
            "idp_export_idp_status": "Statut du PDI",
            "idp_export_idp_percent": "Pourcentage de PDI complété",
            "idp_export_learning_group": "Groupe de formation",
            "idp_export_function": "Fonction / position",
            "idp_export_competencies": "Groupes de compétences",
            "idp_export_skills": "Compétences",
            "idp_export_format": "Format",
            "idp_export_type": "Type",
            "idp_export_resource": "Ressource",
            "idp_export_method": "Méthode",
            "idp_export_event_name": "Nom de l'activité",
            "idp_export_provider": "Prestataire",
            "idp_export_trainer": "Nom de l'entraîneur/mentor",
            "idp_export_duration": "Durée, h",
            "idp_export_course_description": "Description du cours",
            "idp_export_target_group": "Groupe cible",
            "idp_export_program": "Programme",
            "idp_export_learning_materials": "Matériels de formation",
            "idp_export_period": "Période de formation",
            "idp_export_status": "Statut",
            "idp_export_all_hours": "Total des heures",
            "idp_export_all_days": "Total des jours",
            "idp_export_all_trainings": "Total des formations",
            "idp_export_training_employees": "Les journées de formation (Employés)",
            "idp_export_training_result": "Les journées de formation (Total)",
            "idp_export_training_name": "Intitulé de la formation",
            "idp_export_training_type": "Type",
            "idp_export_training_all_hours": "Nombre total d'heures de formation",
            "idp_export_training_days": "Journées de formation",
            "idp_export_training_hours_in_day": "Nombre d'heures de formation par jour",
            "idp_export_training_assign_employees": "Nombre d'employés auxquels la formation a été assignée",
            "idp_export_training_success_employees": "Nombre d'employés ayant suivi la formation",
            "idp_export_training_percent_employees": "Pourcentage d'employés ayant suivi la formation",
            "idp_export_hours_result": "Heures totales",
            "idp_mandatory_export": "Configuration du rapport sur la formation obligatoire",
            "idp_status_export": "Configuration du Rapport: Statut du PDI",
            "idp_export_event_divide": "Сatégorie de cours",
            "idp_export_finish_date": "Date d'achèvement",
            "idp_export_mandatory_learning": "La formation obligatoire",
            "idp_export_fired_status": "Statut",
            "idp_export_fired_status_active": "actif",
            "idp_export_fired_status_fired": "licencié",
            "idp_export_without_fired": "à l'exclusion des feux",
            "idp_export_category": "Catégorie",
            "idp_export_module": "Modules",
            "required_field": "champ obligatoire",
            "only_for_workers": "uniquement pour les employés de première ligne",
            "report_generating": "Le rapport est en cours de génération",
            "successfully_assigned": "attribué avec succès à des employés sélectionnés",
            "successfully_added": "La formation a été ajoutée avec succès à la liste",
            "already_been_added": "La formation a déjà été ajoutée à PDI",
            "to_the_catalog": "Au catalogue",
            "next": "Suviant",
            "select_all": "Tout sélectionner"
        },
        "voc": {
            "download_form": "Formulaire",
            "recruitment_date": "Date d’embauche",
            "transferred_to_another_position": "Transféré à un autre poste",
            "end_of_probation": "Fin de la période d’essai",
            "working": "Travaille",
            "not_working_yet": "Avant le travail",
            "managers": "Responsables",
            "managers_empty": "Pas d'information sur les responsables",
            "manager": "Responsable",
            "functional_managers": "Responsables fonctionnels",
            "functional_managers_empty": "Pas d'information sur les responsables fonctionnels",
            "functional_manager": "Responsable fonctionnel",
            "mentor": "Mentor",
            "choose_you_destiny": "Sélectionnez un employé sur la liste",
            "not_selected": "Non sélectionné",
            "mentor_not_required": "Coach n’est pas nécessaire",
            "newbie_coming_in_3_days": "Début de travail d’un nouveau salarié",
            "table_pernumber": "ID",
            "table_fullname": "Nom complet",
            "table_position": "Poste",
            "table_status_idp": "Statut du PDI",
            "table_date_come": "Date de début de travail",
            "table_status": "Status",
            "table_format": "Format",
            "table_deadline": "Time",
            "table_close_sidebar": "Masquer la liste des employés",
            "table_close_sidebar_employee": "Hide",
            "table_open_sidebar": "Afficher la liste des employés",
            "table_open_sidebar_employee": "Présenter des données personnelles et des informations sur les chefs",
            "table_author": "Auteur",
            "table_series": "Series and number",
            "table_type": "Type",
            "table_reservist": "Réserviste",
            "table_group": "Groupe",
            "table_level": "Niveau",
            "table_name": "Nom de l'activité",
            "table_subdivision": "Subdivision",
            "table_status_activity": "Status activity",
            "report_idp": "Rapport sur le PDI",
            "report_mandatory_learning": "Rapport sur la formation obligatoire",
            "report_training_days_employees": "Rapport sur les journées de formation (Employés)",
            "report_training_days_trainings": "Rapport sur les journées de formation (Formations)",
            "report_wishes": "Rapport sur les souhaits",
            "newbie_no_tasks_after_8_days": "Précision d’une tâche pour la période d’essai",
            "newbie_no_verified_tasks_before_7_days": "Décision selon les résultats de la période d’essai",
            "probation_period_is": "Estimer la période d’essai",
            "waiting_probation_period_decision": "En attente d’une décision",
            "succeed_probation_period_decision": "Réussie",
            "no_assigned_managers": "Non défini",
            "end_of_shift": "Fin du 1er poste",
            "yes": "Oui",
            "no": "Non",
            "all": "Tous",
            "add_mentor_modal_title": "Coach de salarié",
            "mentor_field": "Mentor",
            "mentor_field_default": "Sélectionnez le coach  sur la liste",
            "mentor_add_button": "Désigner",
            "mentor_reset_button": "Supprimer",
            "delete_mentor_error": "Erreur lors de l’élimination du coach. Veuillez contacter le service d’assistance.",
            "mentor_field_can_edit": "Coach peut gérer les tâches",
            "mentor_not_from_same_department": "Le coach doit appartenir à la même division",
            "mentor_not_from_same_company": "Le coach doit appartenir à la même entreprise",
            "mentor_and_newbie_same_user": "Le coach et le salarié ne peuvent pas être la même personne",
            "add_mentor_error": "Erreur lors de l’ajout du coach",
            "error": "Erreur",
            "welcome_home_link": "Accueil",
            "relations": "Communication",
            "mentor_assigned": "Désignation comme coach",
            "no_shift_end": "Non établi",
            "no_feature_for_role": "Désolé votre rôle ne prévoit pas de fonctionnalité",
            "no_copy_tasks": "Pour cette fonction il n’existe pas de tâches précréées.",
            "newbie_no_certificate": "Fonction de téléchargement du certificat n’est pas accessible.",
            "probation_period_success": "Probation is successful!",
            "congrats": "Congratulations and we wish you productive work at Nordgold",
            "download_certificate": "Télécharger le certificat",
            "shift_at": "Fin du 1er poste",
            "your_probe_period_is_end": "Your probation period has been successfully completed.",
            "you_have_not_newbies": "You have no employees on probation period.",
            "control_probation_period_report": "Probation period from %s to %s",
            "group_subdivision": "Employee division",
            "company": "Compagnie",
            "employee_probation_period_status": "Status",
            "employee_probation_period_status_process": "in process",
            "employee_probation_period_status_passed": "passed",
            "employee_probation_period_status_not_passed": "failed",
            "employees": "Employés",
            "catalog": "Catalogue",
            "idp": "PDI",
            "my_idp": "Mon PDI",
            "employee_idp": "Employee IDP",
            "academy_nordgold": "Nordgold Academy",
            "date_create_task": "Tasks setting date",
            "date_evaluate_task": "Tasks evaluation date",
            "date_dismissal": " Termination date",
            "choose_all_companies": "All BU",
            "choose_all_departments": "All departments",
            "mentor_field_filter": "Filter",
            "mentor_field_filter_button": "Search",
            "mentor_field_filter_placeholder": "Employee ID, Surname, Name, Position",
            "short_tab_number": "Emp ID",
            "choose_mentor_from_dropdown_list": "Select mentor from dropdown list",
            "russian": "Russe",
            "english": "Anglais",
            "french": "Français",
            "save": "Sauvegarder",
            "assign": "Assigner",
            "skip": "Sauter",
            "from": "from",
            "to": "to",
            "at": "at",
            "today": "today",
            "yesterday": "yesterday",
            "view_individual_education": "View individual learning",
            "view_common_education": "View learning",
            "view_wish": "View wish",
            "view_event": "View learning",
            "edit_individual_education": "Edit individual learning",
            "edit_common_education": "Edit learning",
            "edit_wish": "Edit wish",
            "edit_event": "Éditer l'activité",
            "create_individual_education": "Create individual learning",
            "create_event": "Créer une activité",
            "copy_event": "Duplication d'événement",
            "create_wish": "Create wish",
            "create_deadline": "Fixer une limite de temps",
            "create_new_deadline": "Create new deadline",
            "is_hidden": "Hidden",
            "delete": "Supprimer",
            "actions": "Actions",
            "warning_actions_employee": "Pour voir les actions disponibles, sélectionnez les employés dans la liste",
            "warning_actions_activity": "Pour voir les actions disponibles, sélectionnez la formation dans le tableau",
            "warning_wishes_activity": "Pour voir les actions disponibles, sélectionnez la demande dans le tableau",
            "loading": "Chargement...",
            "table_event_name": "Nom de la formation",
            "table_direction": "Direction",
            "table_company": "Compagnie",
            "table_periodicity": "Fréquence",
            "male": "Homme",
            "female": "Femme",
            "system_message": "Message système",
            "dated": "daté du",
            "valid_until": "valable jusqu'au",
            "indefinitely": "indéfiniment",
            "active": "Actif",
            "fired": "Licencié",
            "trainings": "Formations",
            "author_assignment": "Auteur de la nomination",
            "last_edit": "Dernière édition",
            "learning_Matrix": "Matrice d'apprentissage",
            "system": "Système",
            "queue": "File d'attente",
            "out_of": "sur",
            "generate_report_error": "Impossible de générer le rapport, sélectionnez une tranche de données plus petite",
            "no_processes": "Aucun processus"
        },
        "admin": {
            "new_emp": "Nouvel employé",
            "new_hr": "New HR",
            "new_mentor": "New mentor",
            "new_manager": "New manager",
            "new_functional_manager": "New functional manager",
            "import": "Import",
            "manual": "Manually",
            "batch": "Package",
            "export": "Export",
            "log_history": "Log history",
            "tab_number": "Employee ID",
            "employee": "Employé",
            "employees": "Employés",
            "company": "Compagnie",
            "business_item": "Business unit",
            "companies": "Companies",
            "no_companies_users": "Users not found",
            "department": "Department",
            "org_5": "Structure organisationnelle : niveau 5",
            "idp_export_employee_status": "Statut de salarié",
            "position": "Position",
            "fired_at": "Fired At",
            "phone": "Phone",
            "in_system": "On probation period",
            "in_white_list": "Sur la liste blanche",
            "source": "Source",
            "employee_add": "Adding a new employee",
            "pernumber": "Employee ID",
            "novice": "Oui",
            "not_novice": "Non",
            "roles": "Rôles",
            "email": "Email",
            "division": "Section",
            "subdivision": "Département",
            "no_division": "Not specified",
            "shift_at": "Shift end at",
            "mentor_can_edit": "Mentor's expanded rights",
            "without_probation": "No probation period",
            "user_not_found": "Employee is not found.",
            "employee_imported": "Employees are imported successfully.",
            "notify_button": "Alertes",
            "config_notification_title": "Employee selection",
            "save_settings": "Sauvegarder",
            "notification_settings_updated": "Notification settings updated",
            "notification_settings_failed_updated": "The BU alert settings have not been updated.",
            "add_provider": "Ajouter un prestataire",
            "provider": "Prestataire",
            "russian": "Russian",
            "english": "English",
            "french": "French",
            "providers": "Prestataires",
            "provider_add_error": "An error occured while creating a provider",
            "provider_edit_error": "An error occured while changing a provider",
            "provider_add_success": "Provider added successfully",
            "provider_edit_success": "Provider changed successfully",
            "provider_delete_success": "Provider has been successfully deleted",
            "can_edit_catalog": "Can work with catalog",
            "report_button": "Report",
            "competences": "Groupes de compétences",
            "rename": "Renommer",
            "delete": "Supprimer",
            "hide": "Rendre inactif",
            "show": "Rendre actif",
            "matrix": "Matrice",
            "be": "BE",
            "fio": "FIO",
            "reservist": "Reservist",
            "group": "Groupe",
            "level": "Level",
            "connections": "Connections",
            "chapter": "Chapter",
            "employee_data": "Données de l'employé",
            "create_employee": "Nouvel employé",
            "create_hr": "New HR",
            "create_manager": "New manager",
            "create_func_manager": "New func. manager",
            "add_group": "Nouveau groupe",
            "add_function": "Ajouter une fonction / position",
            "add_competence": "Ajouter une groupe de compétences",
            "add_skill": "Ajouter une compétence",
            "rename_group": "Renommer le groupe",
            "rename_function": "Renommer la fonction / position",
            "rename_competence": "Renommer le groupe de compétences",
            "rename_skill": "Renommer la compétence",
            "rename_provider": "Renommer le prestataire",
            "delete_provider_question": "Voulez-vous supprimer le prestataire ?",
            "new_provider": "Nouveau prestataire",
            "not_delete": "Vous pouvez supprimer un compte qui figure sur la liste blanche",
            "add_matrix_activity": "Ajouter une formation à la matrice",
            "import_matrix": "Importation",
            "export_matrix": "Exportation",
            "make_active": "Rendre actif",
            "make_not_active": "Rendre inactif",
            "main_qualification": "Qualification (main)",
            "optional_qualification": "Qualification (optional)",
            "pbiot": "PBiOT",
            "first_aid": "First aid",
            "ecology": "Ecology",
            "gnvp": "GNVP",
            "professional": "Professional",
            "one_time": "1 time",
            "one_time_in_year": "1 time in year",
            "one_time_in_two_years": "1 time in 2 years",
            "one_time_in_three_years": "1 time in 3 years",
            "one_time_in_five_years": "1 time in 5 years",
            "one_time_in_ten_years": "1 time in 10 years",
            "active": "Actif",
            "not_active": "Inactif",
            "mandatory": "Mandatory",
            "additional": "Additional",
            "certificate": "Certificate",
            "qualification_certificate": "Qualification certificate",
            "protocol": "Protocol",
            "protocol_identity": "Protocol / identity",
            "create_matrix": "Ajouter une formation obligatoire",
            "edit_matrix": "Rédaction de la formation obligatoire",
            "direction": "Direction",
            "priority": "Priority",
            "documents": "Documents",
            "periodicity": "Fréquence",
            "activity_link": "Lien vers la formation dans le \"Catalogue\"",
            "matrix_import_error": "The learning matrix cannot be imported \nbecause one or more of the fields \ndoes not match the specified format. \nCheck the file and upload the correct version again.",
            "matrix_activity_already_exists": "Matrix activity already exists",
            "all_departments": "All departments"
        },
        "role": {
            "admin": "Administrateur",
            "manager": "Responsable",
            "managers": "Responsables",
            "fmanager": "Responsable fonctionnel",
            "fmanagers": "Responsables fonctionnels",
            "employee": "Employé",
            "employees": "Employés",
            "mentor": "Coach",
            "hr": "RH",
            "newbie": "Nouveau salarié"
        },
        "idp": {
            "search_placeholder": "Find employees",
            "employee_list": "Liste des employés",
            "star_tooltip": "This employee is on the list of <br> reservists and is eligible for a <br> promotion in the near future",
            "fires_tooltip": "fired",
            "employees": "Employés",
            "men": "personnes | personn | personnes | personnes",
            "download": "Télécharger",
            "download_report": "Télécharger le rapport",
            "individual_development_plan": "Plan de développement individuel",
            "not_formed": "Non formé",
            "on_approval": "En cours d'approbation",
            "on_approval_employee_list": "À approuver",
            "agreed_by_manager": "Approuvé par le responsable",
            "agreed_by_hr": "Agree by HR",
            "agreed_by_hr_employee_list": "Approuvé",
            "for": "pour",
            "send_to_approve_idp": "Soumettre pour approbation",
            "assign_idp": "Approuver le PDI",
            "assign_wish": "Approuver les souhaits",
            "assign_all_wishes": "Approuver tous les souhaits",
            "assign_not_assigned": "Assign uncoordinated learning",
            "add_learning_from_catalog": "Ajouter une formation à partir du catalogue",
            "mark_learning_as_complete": "Mark learning as complete",
            "change_learning_status": "Changer le statut de la formation",
            "load_files": "Télécharger des fichiers",
            "all_years": "All years",
            "yr": "г.",
            "filter_event_by_status": "Status filter",
            "competencies": "Groupes de compétences",
            "when": "When",
            "type": "Type",
            "add": "Ajouter une formation",
            "assign": "Assigner",
            "complete": "Complete",
            "pending": "En cours d'approbation",
            "approved": "Approuvé par les RH",
            "assigned": "Assigné",
            "inprogress": "En cours",
            "assigned_for_wish": "Approuvé",
            "rejected": "Rejeté",
            "canceled": "Annulé",
            "canceled_wish": "Reporté",
            "available": "Disponible à l'Académie",
            "done": "Complété",
            "notdone": "Non complété",
            "expired": "Expiré",
            "mandatory": "Mandatory",
            "addition": "Additional",
            "additional": "Additional",
            "mandatory_security": "Safety Commitment",
            "learnings": "Formation assignée à l'employé",
            "learnings_employee": "La formation qui vous a été assignée",
            "wishes_txt": "Souhaits de formation de l'employé",
            "wishes_txt_employee": "Vos demandes de formation",
            "mandatory_tooltip": "This block contains mandatory events that HR adds. You can also add events from the catalog or create them yourself in agreement with HR or the manager.",
            "additional_tooltip": "This block contains <b><u>optional</u></b> for completing the event that HR adds. You can also add events from the catalog or create them yourself in agreement with HR or the manager.",
            "mandatory_security_tooltip": "Events, courses and other developmental activities that are necessary to comply with occupational safety requirements.",
            "wishes_tooltip": "Autres conseils individuels non prioritaires que l'employé peut recevoir en plus des activités de développement de base.",
            "assign_not_assigned_help": "The child status you selected is automatically set for all <br> inconsistent training in the \"Draft\" status",
            "learning_tooltip": "Activités, cours et autres actions de développement qui sont nécessaires en priorité pour atteindre les objectifs fixés, développer et/ou renforcer les habiletés professionnelles et personnelles clés.",
            "status_tooltip": "Les instructions pour l'approbation du PDI peuvent être téléchargées en format PDF en cliquant sur le <a href='/' target='_blank'><b><u>lien</u></b> </a> <br> Afin d'approuver le PDI, tous les souhaits ajoutés par l'employé doivent être approuvés ou rejetés",
            "assign_wishes_help": "Le statut que vous avez sélectionné sera automatiquement appliqué à tous les souhaits dans le statut “En cours d'approbation“. <br>Attention ! Tous les souhaits de formation du Catalogue seront ajoutés au bloc “Formation qui a été ajoutée pour l'employé“ avec le statut “Assigné“.",
            "wish_tooltip": "The agreed wishes are transferred to the role. In accordance with them, training will be added to the catalog or to the employees IDP.",
            "catalog": "Catalog IDP",
            "course": "Cours à l'Académie NG",
            "event": "Activités à l'Académie NG",
            "external": "Hors de la plateforme",
            "individual": "Individuel",
            "wishes": "Employee wish",
            "matrix": "Learning matrix",
            "others": "Others",
            "not_found_mandatory": "Learning has not been added yet. Check the filter by status",
            "not_found_mandatory_security": "Security commitments not yet added or do not match status filters",
            "not_found_addition": "Learning has not been added yet. Check the filter by status",
            "not_found_wishes": "Wishes not yet added or do not match status filters",
            "f_of": "Full-time",
            "f_or": "Remote",
            "f_oroli": "Remote (OLIMPOKS)",
            "f_ofr": "Full-time / remote",
            "m_ow": "Sur le lieu de travail",
            "create_individual": "Create individual",
            "create": "Créer",
            "checkout": "Create",
            "create_wish": "Faire une demande",
            "add_from_catalog": "Sélectionner à partir du catalogue",
            "cm_view": "View",
            "cm_view_edit": "View / edit",
            "cm_comment": "Laisser un commentaire",
            "cm_reject": "Reject",
            "cm_assign": "Approuver",
            "cm_delete": "Supprimer",
            "cm_duplicate": "Dupliquer",
            "cm_move_to_mandatory": "To the mandatory",
            "cm_move_to_additional": "To the additional",
            "cm_move_to_mandatory_security": "To the mandatory for security",
            "cm_attach_files": "Joindre des fichiers",
            "cm_mark_as_done": "Mark as done",
            "cm_attach_new_files": "Attach new files",
            "cm_set_new_deadline": "Set a new time",
            "cm_cancel": "Cancel",
            "cm_cancel_wish": "Cancel",
            "cm_assign_hr": "Assigner",
            "cm_approve": "Approuver",
            "cm_mark_as_in_process": "Mark ass “In process”",
            "cm_mark_as_not_done": "Mark as not done",
            "comment": "comments | comment | comment | comments",
            "file": "fichiers | fichier | fichier | fichiers",
            "write_comment": "Laisser un commentaire",
            "has_expired_activities": "Il y a une formation expirée",
            "has_inconsistent_activities": "Has inconsistent activities",
            "has_new_wishes": "Il y a de nouveaux souhaits",
            "till": "till",
            "employee": "Employé",
            "hr": "RH",
            "manager": "Responsable",
            "format_at_workplace": "Sur le lieu de travail",
            "format_interaction": "Interaction",
            "format_training": "Formation",
            "type_in_person": "En présentiel",
            "type_online": "En ligne",
            "type_mix": "Mixte",
            "resource_external": "Externe",
            "resource_internal": "Interne",
            "method_mentorship": "Mentorat",
            "method_coaching": "Coaching",
            "method_internship": "Stage",
            "method_self_improvement": "Développement personnel",
            "method_participation": "Participation à des projets",
            "added_by_you": "Ajouté par vous",
            "target_group_hr": "Responsables",
            "target_group_specialists": "Spécialistes",
            "target_group_workers": "Employés de première ligne",
            "change_learning_statuses": "Modifier les statuts de formation",
            "change_learning_status_help": "Les statuts de formation ne peuvent être modifiés que dans les PDI approuvés pour les formations qui ne sont pas dispensées sur des plateformes externes (Nordgold Academy). <br><br>Veuillez noter que la formation individuelle doit être approuvée individuellement pour chaque employé!",
            "select_learning_activity": "Sélectionnez une formation dans la liste ci-dessous",
            "display_only_with_assigned_learning": "The list of employees displays only those for whom this training was added to the IPR, as well as the status of this training. Choose the one you want to install. Some statuses may not be available.",
            "attach_files_help": "Dans cette fenêtre, vous pouvez télécharger des fichiers (par exemple, des certificats d'achèvement) pour tous les employés dont la formation a été ajoutée au PDI, quel que soit le statut. <br>Cette option n'est disponible que pour les formations ajoutées à partir du catalogue.",
            "display_all_status_learning": "The list of employees displays only those for whom this training was added to the IPR in any status.",
            "select_for_all": "Sélectionner pour tous",
            "empty_wish_list": "Les souhaits n'ont pas encore été ajoutés ou ne correspondent pas aux filtres mis en place",
            "empty_learnings_list": "Aucune affectation pour la période ou les filtres sélectionnés",
            "learning_for": "Learning for",
            "y": "y.",
            "you": "You",
            "not_found_assignments": "Aucune affectation pour la période ou les filtres sélectionnéss",
            "per_page": " sur la page"
        },
        "catalog": {
            "add_to_idp": "Ajouter au PDI",
            "dont_you_found": "Vous ne trouvez pas un programme ou une activité?",
            "you_can_create_new": "Faites une demande ou créez une formation individuelle dans votre PDI",
            "create_event": "Créer une activité",
            "view_event": "View event",
            "edit_event": "Éditer l'activité",
            "import_from_excel": "Importation depuis Excel",
            "assign": "Ajouter au PDI",
            "if_not_found_create_new": "Can't find a program or event?<br>Create a wish or an individual task",
            "assign_as": "how",
            "was_assign_for": "Pour ",
            "events_and_programs": "programmes/activités ou souhaits",
            "was_assign_users": " employees have already been assigned",
            "assign_search_group": "Trouver un groupe",
            "assign_need_activity": "Au moins une position doit être sélectionnée",
            "was_assign_show_users": "View Employees",
            "was_assign_assignments": "View appointments",
            "assigned_activities": "Events and programs have already been scheduled",
            "assignment_title": "Dans le PDI des employés:",
            "code": "Code",
            "name": "Nom de l'activité",
            "competencies": "Groupe de compétences",
            "source": "Source",
            "competence": "Groupe de compétences",
            "skills": "Compétences",
            "all": "Tous",
            "format": "Format",
            "format_at_workplace": "Sur le lieu de travail",
            "format_webinar": "Online course / webinar",
            "format_offline": "Training / offline program",
            "method_at_workplace": "Sur le lieu de travail",
            "method_internal_training_by_trainer": "Internal training by BU trainer (at BU)",
            "method_internal_training_by_external_trainer": "Internal training by an external trainer (on BU)",
            "method_external_group": "External group training (not on BU)",
            "method_external_individual": "External individual training (not on BU)",
            "method_probation": "Internship at other Nordgold enterprises",
            "method_webinar": "Online course / webinar",
            "author": "Auteur",
            "group": "Groupe",
            "function": "Fonction / position",
            "type": "Type",
            "resource": "Ressource",
            "method": "Méthode",
            "trainer_fio": "Nom de l'entraîneur/mentor",
            "duration": "Durée, h",
            "provider": "Prestataire",
            "target_group": "Groupe cible",
            "competence_skill": "Compétences",
            "program": "Programme",
            "educational_materials": "Matériels de formation",
            "category": "Category",
            "employee": "Staff",
            "when": "Date limite",
            "mass_deadline_for_all": "Set a deadline for everyone at once",
            "mass_deadline_for_one": "Set a deadline",
            "mass_deadline_for_every": "Or set a deadline for each employee individually",
            "set_new_deadline": "Set a new deadline",
            "period": "Period",
            "comment": "Commentaire",
            "link": "Link",
            "link_edit": "Link (if there is)",
            "description": "Description du cours",
            "search_any_way": "Search all over",
            "view": "View",
            "cm_view": "View",
            "view_edit": "View / Edit ",
            "edit": "Edit",
            "assign_to_employees": "Assigner aux employés",
            "add_as_mandatory": "Add to IDP as mandatory",
            "add_as_additional": "Add to IPR as an additional",
            "add_as_security_commitment": "Add to IPR as a Security Commitment",
            "view_assignment": "Voir les affectations",
            "not_fully_valid": "All required fields are <br> not filled in the card",
            "mass_period": "Modifier la période",
            "set_new_period": "Définir la période",
            "common_for_all": "Commun à toutes les formations",
            "name_placeholder": "Enter the name",
            "add_competence": "Ajouter une groupe de compétences",
            "add_another_competence": "Ajouter une autre groupe de compétences",
            "what_to_do": "What should be done",
            "how_to_develop": "How do I develop it?",
            "priority": "Priority",
            "additional_info": "Additional Information",
            "additional_info_helper": "Specify the provider, the link to the event or other important information",
            "clear_competence": "Supprimer",
            "add_skill": "Ajouter une compétence",
            "add_another_skill": "+Ajouter une autre compétence",
            "add_another_files": "+Ajouter d'autres fichiers",
            "choose_competence": "Choose a competency",
            "choose_format_method": "Choose format",
            "choose_skill": "Choisissez une compétence",
            "course": "Course at NG Academy",
            "event": "Event at NG Academy",
            "external": "Off platform",
            "wishes": "Wishes",
            "start_typing_for_search": "Start typing to search",
            "no_result_name": "No results for",
            "template": "Modèle",
            "create_template": "Create Template",
            "edit_template": "Edit Template",
            "template_name": "Template name",
            "add_event": "Add event",
            "event_placeholder": "Choose a program or event",
            "selected_event": "Selected events",
            "hide_expired": "Masquer les expirées",
            "hide_inactive": "Cacher les inactifs",
            "learning": "Learning \"",
            "learning_already_exists": "\" has already been added to your IDP",
            "learning_already_exists_in_employee": "\" has already been added to employee IDP",
            "go_to_my_idp": "Go to my IDP",
            "go_to_employee_idp": "Go to employee IDP",
            "mass_assign_alert_1": "La formation",
            "mass_assign_alert_2": "déjà été assignée aux employés que vous avez sélectionnés",
            "available_by": "disponible via",
            "ekvio_link": "le lien",
            "employee_type_specialist_manager": "Specialist-manager",
            "employee_type_common_employee": "Common employee"
        }
    },
    "ru": {
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "Поле обязательно для заполнения.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "{attribute} уже занят.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "plan_greater_probation": "Планируемая дата позднее даты окончания испытательного срока.",
            "you_have_no_assigned_tasks": "У вас есть не назначенные задачи.",
            "path_to_file_corrupt": "Путь до файла пуст или повреждён.",
            "task_without_plan_date": "Есть задачи без планируемого срока выполнения.",
            "you_have_no_tasks": "Нет назначенных заданий.",
            "report_settings_required": "Заполните все поля.",
            "report_company_not_exist": "Такой компании не существует.",
            "report_bad_date_format": "Неверный формат дат периода отчета.",
            "can_not_be_competence": "Не может быть компетенцией.",
            "can_not_be_not_competence": "Не может быть группой/подгруппой.",
            "can_not_hide_not_competence": "Нельзя скрыть группу/подгруппу.",
            "can_not_remove_not_empty_group": "Нельзя удалить не пуступ группу/подгруппу.",
            "can_not_remove_assigned_competence": "Нельзя удалить компетенцию, которая прикреплена к мероприятию/курсу.",
            "can_not_remove_assigned_skill": "Нельзя удалить навык, который прикреплен к мероприятию/курсу.",
            "can_not_remove_assigned_group": "Нельзя удалить группу, которая прикреплена к мероприятию/курсу.",
            "can_not_remove_assigned_function": "Нельзя удалить функцию, которая прикреплена к мероприятию/курсу.",
            "can_not_add_skill_to_competence": "Нельзя добавить навык к не компетенции.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "name": "ФИО",
                "pernumber": "Табельный номер"
            },
            "import": {
                "pernumber_empty": "Не указан табельный номер",
                "pernumber_only_digits": "Табельный номер может содержать только числа",
                "pernumber_not_unique": "Неуникальный табельный номер",
                "surname_not_exists": "Не заполнена фамилия сотрудника",
                "firstname_not_exists": "Не заполнено имя сотрудника",
                "invalid_phone": "Неверный формат номера телефона. Допускается от 11 до 16 числовых символов",
                "not_unique_phone": "Неуникальный номер телефона",
                "invalid_email": "Неверный формат для электронной почты",
                "not_unique_email": "Неуникальная электронная почта",
                "empty_company": "Не заполнена компания сотрудника",
                "not_exist_company": "В системе нет такой компании",
                "empty_department": "Не заполнен раздел сотрудника",
                "not_exist_department": "В системе нет такого раздела сотрудника",
                "empty_position": "Не заполнена должность сотрудника",
                "not_exist_position": "В системе нет такой должности",
                "hired_empty": "Не заполнена дата принятия на работу",
                "invalid_date_format_hired": "Неверный формат даты принятия на работу. Допускается формат 01/01/2020",
                "invalid_date_format_shift": "Неверный формат даты даты окончания вахты. Допускается формат 01/01/2020",
                "invalid_date_format_period": "Неверный формат даты конца испытательного срока. Допускается формат 01/01/2020",
                "save_user_error": "Ошибка при сохранении пользователя",
                "not_exist_subdivision": "В системе нет такого подразделения"
            }
        },
        "auth": {
            "login-header": "Авторизуйтесь в модуле ИПР",
            "remember-me": "Запомнить меня",
            "login": "Войти",
            "logout": "Выйти",
            "pernumber": "Табeльный номер",
            "password": "Пароль",
            "register": "Зарегистрироваться",
            "failed": "Неверный табельный номер или пароль. Проверьте еще раз",
            "throttle": "Много попыток авторизации. Попробуйте снова через {seconds} с.",
            "token_not_found": "Токен пользователя не найден."
        },
        "modal": {
            "when_placeholder": "Выберите даты проведения",
            "provider_placeholder": "Выберите провайдера",
            "place_placeholder": "Укажите место проведения",
            "duration_placeholder": "Впишите длительность в часах",
            "link_placeholder": "Вставьте ссылку",
            "comment_placeholder": "Впишите комментарий",
            "description_placeholder": "Впишите описание",
            "attached_by_you": "Прикреплено вами",
            "attached_by_hr": "Прикреплено HR",
            "attached_by_manager": "Прикреплено руководителем",
            "attached_by_employee": "Прикреплено сотрудником",
            "created_by_you": "Добавлено вами",
            "created_by_hr": "Добавлено HR",
            "created_by_manager": "Добавлено руководителем",
            "created_by_fmanager": "Добавлено функц. руководителем",
            "created_by_employee": "Добавлено сотрудником",
            "delete": "Удалить",
            "delete_question": "Вы хотите удалить файл?",
            "delete_employee_question": "Вы хотите удалить учетную запись?",
            "delete_hr_link_question": "Вы хотите удалить привязку HR?",
            "delete_manager_link_question": "Вы хотите удалить привязку руководителя?",
            "delete_fmanager_link_question": "Вы хотите удалить привязку функц. руководителя?",
            "cancel": "Отмена",
            "files_input_placeholder": "Кликните и выберите файл на устройстве или перетащите сюда",
            "drop_placeholder": "Перетащите файл сюда",
            "big_file_error": "Объем файла, который вы пытались загрузить, больше 10 МБ. Проверьте и загрузите файл допустимого размера.",
            "show_only_necessary_fields": "Показать только необходимые поля",
            "add_training": "Добавление тренинга",
            "add_training_description_1": "Выбранное Вами обучение",
            "add_training_description_2": "проводится в формате тренинга. Это означает, что оно будет добавлено в список “Пожеланий” и должно быть согласованно Вашим HR. Все равно хотите добавить?",
            "add": "Добавить",
            "manager": "Руководитель",
            "fmanager": "Функц. руковолитель",
            "employee": "Сотрудник",
            "idp_export": "Настройка отчета по ИПР",
            "wish_export": "Настройка отчета по пожеланиям",
            "training_export": "Настройка отчета по тренинговым дням",
            "idp_export_download": "Сформировать отчет",
            "idp_export_year": "Выберите период",
            "idp_export_tab_type": "Выберите вкладки",
            "idp_export_row": "Выберите поля",
            "idp_export_wish": "Пожелания",
            "idp_export_learning": "Обучение",
            "idp_export_pernumber": "ТН",
            "idp_export_fio": "ФИО",
            "idp_export_position": "Должность",
            "idp_export_employee_type": "Тип сотрудника",
            "idp_export_reservist": "Резервист",
            "idp_export_employee_group": "Группа сотрудника",
            "idp_export_sex": "Пол",
            "idp_export_bu": "Бизнес-единица",
            "idp_export_department": "Отдел",
            "idp_export_division": "Раздел",
            "idp_export_subdivision": "Подразделение",
            "idp_export_org_5": "Орг. структура: 5 уровень",
            "idp_export_org_6": "Орг. структура: 6 уровень",
            "idp_export_org_7": "Орг. структура: 7 уровень",
            "idp_export_org_8": "Орг. структура: 8 уровень",
            "idp_export_employee_status": "Статус сотрудника",
            "idp_export_supervisor": "Непосредственный руководитель",
            "idp_export_idp_year": "Год ИПР",
            "idp_export_idp_status": "Статус ИПР",
            "idp_export_idp_percent": "Процент прохождения ИПР",
            "idp_export_learning_group": "Группа обучения",
            "idp_export_function": "Функция / должность",
            "idp_export_competencies": "Компетенции",
            "idp_export_skills": "Навыки",
            "idp_export_format": "Формат",
            "idp_export_type": "Тип",
            "idp_export_resource": "Ресурс",
            "idp_export_method": "Метод",
            "idp_export_event_name": "Название мероприятия",
            "idp_export_provider": "Провайдер",
            "idp_export_trainer": "ФИО тренера/наставника",
            "idp_export_duration": "Продолжительность, ч",
            "idp_export_course_description": "Описание курса",
            "idp_export_target_group": "Целевая группа",
            "idp_export_program": "Программа",
            "idp_export_learning_materials": "Учебные материалы",
            "idp_export_period": "Срок обучения",
            "idp_export_status": "Статус",
            "idp_export_all_hours": "Всего часов",
            "idp_export_all_days": "Всего дней",
            "idp_export_all_trainings": "Всего тренингов",
            "idp_export_training_employees": "Тренинговые дни (сотрудники)",
            "idp_export_training_result": "Тренинговые дни (итог)",
            "idp_export_training_name": "Название тренинга",
            "idp_export_training_type": "Тип тренинга",
            "idp_export_training_all_hours": "Общее количество часов в тренинге",
            "idp_export_training_days": "Тренинговые дни",
            "idp_export_training_hours_in_day": "Количество тренинговых часов в день",
            "idp_export_training_assign_employees": "Количество сотрудников, которым был назначен тренинг",
            "idp_export_training_success_employees": "Количество сотрудников, прошедших тренинг",
            "idp_export_training_percent_employees": "Процент сотрудников, прошедших тренинг",
            "idp_export_hours_result": "Итого часов",
            "idp_mandatory_export": "Настройка отчета по обязательному обучению",
            "idp_status_export": "Настройка Отчета: Статус ИПР",
            "idp_export_event_divide": "Раздел курса",
            "idp_export_finish_date": "Дата прохождения",
            "idp_export_mandatory_learning": "Обязательное обучение",
            "idp_export_fired_status": "Статус",
            "idp_export_fired_status_active": "активный",
            "idp_export_fired_status_fired": "уволен",
            "idp_export_without_fired": "без уволенных",
            "idp_export_category": "Категория",
            "idp_export_module": "Модуль",
            "required_field": "обязательное поле",
            "only_for_workers": "только для рабочих",
            "report_generating": "Отчет формируется",
            "successfully_assigned": "успешно назначено выбранным вами сотрудникам",
            "successfully_added": "Обучение добавлено в ИПР",
            "already_been_added": "Обучение уже было добавлено в ИПР ранее",
            "to_the_catalog": "В каталог",
            "next": "Далее",
            "select_all": "Выбрать всё"
        },
        "voc": {
            "download_form": "Форма",
            "recruitment_date": "Дата приёма",
            "transferred_to_another_position": "Переведён на другую должность",
            "end_of_probation": "Окончание испыт. срока",
            "working": "Работает",
            "not_working_yet": "До начала работы",
            "managers": "Руководители",
            "managers_empty": "Нет информации о руководителях",
            "manager": "Руководитель",
            "functional_managers": "Функциональные руководители",
            "functional_managers_empty": "Нет информации о функциональных руководителях",
            "functional_manager": "Функциональный руководитель",
            "mentor": "Наставник",
            "choose_you_destiny": "Выберите сотрудника из списка",
            "not_selected": "Не выбран",
            "mentor_not_required": "Наставник необязателен",
            "newbie_coming_in_3_days": "Выход нового сотрудника",
            "table_pernumber": "Т/н",
            "table_fullname": "ФИО",
            "table_position": "Должность",
            "table_status_idp": "Статус ИПР",
            "table_date_come": "Дата выхода",
            "table_status": "Статус",
            "table_format": "Формат",
            "table_deadline": "Срок",
            "table_close_sidebar": "Скрыть список сотрудников",
            "table_close_sidebar_employee": "Скрыть",
            "table_open_sidebar": "Показать список сотрудников",
            "table_open_sidebar_employee": "Показать персональные данные и информацию о руководителях",
            "table_author": "Автор",
            "table_series": "Серия и номер",
            "table_type": "Тип",
            "table_reservist": "Резервист",
            "table_group": "Группа",
            "table_level": "Уровень",
            "table_name": "Название мероприятия",
            "table_subdivision": "Подразделение",
            "table_status_activity": "Статус обучения",
            "report_idp": "Отчет по ИПР",
            "report_mandatory_learning": "Отчет по обязательному обучению",
            "report_training_days_employees": "Отчет по тренинговым дням (Сотрудники)",
            "report_training_days_trainings": "Отчет по тренинговым дням (Тренинги)",
            "report_wishes": "Отчет по пожеланиям",
            "newbie_no_tasks_after_8_days": "Постановка задач на испытательный срок",
            "newbie_no_verified_tasks_before_7_days": "Решение по результатам испытательного срока",
            "probation_period_is": "Испытательный срок считать",
            "waiting_probation_period_decision": "Ожидание решения",
            "succeed_probation_period_decision": "Успешно завершенным",
            "no_assigned_managers": "Не назначено",
            "end_of_shift": "Окончание 1 вахты",
            "yes": "Да",
            "no": "Нет",
            "all": "Все",
            "add_mentor_modal_title": "Наставник сотрудника",
            "mentor_field": "Наставник",
            "mentor_field_default": "Выберите наставника из списка",
            "mentor_add_button": "Назначить",
            "mentor_reset_button": "Удалить",
            "delete_mentor_error": "Ошибка при удалении наставника. Обратитесь в службу поддержки.",
            "mentor_field_can_edit": "Может управлять заданиями",
            "mentor_not_from_same_department": "Наставник должен быть из того же подразделения",
            "mentor_not_from_same_company": "Наставник должен быть из той же компании",
            "mentor_and_newbie_same_user": "Наставник и сотрудник не могут быть одинаковым",
            "add_mentor_error": "Ошибка при добавлении наставника",
            "error": "Error",
            "welcome_home_link": "Главная",
            "relations": "Связи",
            "mentor_assigned": "Назначение наставником",
            "no_shift_end": "Не установлено",
            "no_feature_for_role": "Извините, но для вашей роли не предусмотрено функционала",
            "no_copy_tasks": "Для этой должности нет ранее созданных задач.",
            "probation_period_success": "Испытательный срок пройден успешно!",
            "congrats": "Поздравляем и желаем продуктивной работы в Nordgold",
            "download_certificate": "Скачать сертификат",
            "newbie_no_certificate": "Функция загрузки сертификата не доступна.",
            "shift_at": "Окончание 1 вахты",
            "your_probe_period_is_end": "Ваш испытательный срок успешно завершен.",
            "you_have_not_newbies": "У вас нет сотрудников на испытательном сроке.",
            "control_probation_period_report": "Контроль прохождения испытательного срока с %s по %s",
            "group_subdivision": "Раздел сотрудника",
            "company": "Компания",
            "employee_probation_period_status": "Статус",
            "employee_probation_period_status_process": "в процессе",
            "employee_probation_period_status_passed": "прошел",
            "employee_probation_period_status_not_passed": "не прошел",
            "employees": "Сотрудники",
            "catalog": "Каталог",
            "idp": "ИПР",
            "my_idp": "Мой ИПР",
            "employee_idp": "ИПР сотрудника",
            "academy_nordgold": "Nordgold Academy",
            "date_create_task": "Дата постановки задачи",
            "date_evaluate_task": "Дата оценки задачи",
            "date_dismissal": "Дата увольнения",
            "choose_all_companies": "Все компании",
            "choose_all_departments": "Все подразделения",
            "mentor_field_filter": "Фильтр",
            "mentor_field_filter_button": "Поиск",
            "mentor_field_filter_placeholder": "ФИО, должность, табельный номер",
            "short_tab_number": "Таб.номер",
            "choose_mentor_from_dropdown_list": "Выберите наставника из списка",
            "russian": "Русский",
            "english": "Английский",
            "french": "Французский",
            "save": "Сохранить",
            "assign": "Назначить",
            "skip": "Пропустить",
            "from": "с",
            "to": "по",
            "at": "в",
            "today": "сегодня",
            "yesterday": "вчера",
            "view_individual_education": "Просмотр индивидуального обучения",
            "view_common_education": "Просмотр обучения",
            "view_wish": "Просмотр пожелания",
            "view_event": "Просмотр мероприятия",
            "edit_individual_education": "Редактирование индивидуального обучения",
            "edit_common_education": "Редактирование обучения",
            "edit_wish": "Редактирование пожелания",
            "edit_event": "Редактирование мероприятия",
            "create_individual_education": "Создание индивидуального обучения",
            "create_event": "Создать мероприятие",
            "copy_event": "Дублирование мероприятия",
            "create_wish": "Создание мероприятия",
            "create_deadline": "Установить срок",
            "create_new_deadline": "Установить новый срок",
            "is_hidden": "Скрыт",
            "delete": "Удалить",
            "actions": "Действия",
            "warning_actions_employee": "Чтобы посмотреть доступные действия, выберите сотрудников из списка",
            "warning_actions_activity": "Чтобы посмотреть доступные действия, выберите обучение в таблице",
            "warning_wishes_activity": "Чтобы посмотреть доступные действия, выберите пожелание в таблице",
            "loading": "Загрузка...",
            "table_event_name": "Название обучения",
            "table_direction": "Направление",
            "table_company": "Компания",
            "table_periodicity": "Периодичность",
            "male": "Мужской",
            "female": "Женский",
            "system_message": "Системное сообщение",
            "dated": "от",
            "valid_until": "действительно до",
            "indefinitely": "бессрочно",
            "active": "Активный",
            "fired": "Уволен",
            "trainings": "Тренинги",
            "author_assignment": "Автор назначения",
            "last_edit": "Последнее редактирование",
            "learning_Matrix": "Матрица обучений",
            "system": "Система",
            "queue": "Очередь",
            "out_of": "из",
            "generate_report_error": "Не удалось сформировать отчёт, выберите меньший срез данных",
            "no_processes": "Нет процессов"
        },
        "admin": {
            "new_emp": "Новый сотрудник",
            "new_hr": "Новый HR",
            "new_mentor": "Новый наставник",
            "new_manager": "Новый руководитель",
            "new_functional_manager": "Новый функц. руководитель",
            "import": "Импорт",
            "manual": "Вручную",
            "Batch": "Пакетная",
            "export": "Экспорт",
            "log_history": "История логов",
            "tab_number": "Табельный номер",
            "employee": "Сотрудник",
            "employees": "Сотрудники",
            "company": "Компания",
            "business_item": "Бизнес-единица (БЕ)",
            "companies": "Компании",
            "no_companies_users": "Пользователи не найдены",
            "department": "Отдел",
            "org_5": "Орг. структура: 5 уровень",
            "position": "Должность",
            "fired_at": "Дата увольнения",
            "phone": "Телефон",
            "in_system": "На исп. сроке",
            "in_white_list": "В белом списке",
            "source": "Источник",
            "employee_add": "Добавление нового сотрудника",
            "pernumber": "Табельный номер",
            "novice": "Да",
            "not_novice": "Нет",
            "roles": "Роли",
            "email": "Email",
            "division": "Раздел",
            "subdivision": "Подразделение",
            "no_division": "Не указано",
            "mentor_can_edit": "Расширенные права наставника",
            "without_probation": "Не предусмотрен испытательный срок",
            "user_not_found": "Сотрудник не найден.",
            "employee_imported": "Сотрудники успешно импортированы.",
            "notify_button": "Оповещения",
            "config_notification_title": "Выбрать сотрудников",
            "save_settings": "Сохранить",
            "notification_settings_updated": "Настройки оповещения БЕ обновлены.",
            "notification_settings_failed_updated": "Настройки оповещения БЕ не обновлены.",
            "add_provider": "Добавить поставщика",
            "provider": "Провайдер",
            "russian": "Русский",
            "english": "Английский",
            "french": "Французский",
            "providers": "Провайдеры",
            "provider_add_error": "При добавлении поставщика возникла ошибка",
            "provider_edit_error": "При редактировании поставщика возникла ошибка",
            "provider_add_success": "Поставщик успешно добавлен",
            "provider_edit_success": "Поставщик успешно изменен",
            "provider_delete_success": "Поставщик успешно удален",
            "can_edit_catalog": "Может работать с каталогом",
            "report_button": "Отчет",
            "competences": "Компетенции",
            "rename": "Переименовать",
            "delete": "Удалить",
            "hide": "Сделать неактивной",
            "show": "Сделать активной",
            "matrix": "Матрица",
            "be": "БЕ",
            "fio": "ФИО",
            "reservist": "Резервист",
            "group": "Группа",
            "level": "Уровень",
            "connections": "Связи",
            "chapter": "Раздел",
            "employee_data": "Данные сотрудника",
            "create_employee": "Новый сотрудник",
            "create_hr": "Новый HR",
            "create_manager": "Новый руководитель",
            "create_func_manager": "Новый функц. руководитель",
            "add_group": "Новая группа",
            "add_function": "Добавить функцию / должность",
            "add_competence": "Добавить кластер компетенций / группу навыков",
            "add_skill": "Добавить навык / компетенцию",
            "rename_group": "Переименовать группу",
            "rename_function": "Переименовать функцию / должность",
            "rename_competence": "Переименовать кластер компетенций / группу навыков",
            "rename_skill": "Переименовать навык / компетенцию",
            "rename_provider": "Переименовать поставщика",
            "delete_provider_question": "Вы хотите удалить поставщика?",
            "new_provider": "Новый поставщик",
            "not_delete": "Вы можете удалить ту учетную запись, которая входит в белый список",
            "add_matrix_activity": "Добавить обучение в матрицу",
            "import_matrix": "Импорт",
            "export_matrix": "Экспорт",
            "make_active": "Сделать активным",
            "make_not_active": "Сделать неактивным",
            "main_qualification": "Квалификация (основная)",
            "optional_qualification": "Квалификация (дополнительная)",
            "pbiot": "ПБиОТ",
            "first_aid": "Первая помощь",
            "ecology": "Экология",
            "gnvp": "ГНВП",
            "professional": "Профессиональное",
            "one_time": "1 раз",
            "one_time_in_year": "1 раз в год",
            "one_time_in_two_years": "1 раз в 2 года",
            "one_time_in_three_years": "1 раз в 3 года",
            "one_time_in_five_years": "1 раз в 5 лет",
            "one_time_in_ten_years": "1 раз в 10 лет",
            "active": "Активно",
            "not_active": "Неактивно",
            "mandatory": "Обязательное",
            "additional": "Дополнительное",
            "certificate": "Сертификат",
            "qualification_certificate": "Квалификационное удостоверение",
            "protocol": "Протокол",
            "protocol_identity": "Протокол / удостоверение",
            "create_matrix": "Добавить обязательное обучение",
            "edit_matrix": "Редактирование обязательного обучения",
            "direction": "Направление",
            "priority": "Приоритет",
            "documents": "Документы",
            "periodicity": "Периодичность",
            "activity_link": "Ссылка на обучение в \"Каталоге\"",
            "matrix_import_error": "Импорт матрицы обучения невозможен, \nтак как одно  или несколько полей не соответствует \nустановленному формату. \nПроверьте файл и загрузите корректную версию еще раз.",
            "matrix_activity_already_exists": "Такая запись уже есть в матрице",
            "all_departments": "Все разделы"
        },
        "role": {
            "admin": "Администратор",
            "manager": "Руководитель",
            "managers": "Руководители",
            "fmanager": "Функциональный руководитель",
            "fmanagers": "Функциональные руководители",
            "employee": "Сотрудник",
            "employees": "Сотрудники",
            "mentor": "Наставник",
            "hr": "HR",
            "newbie": "Новый сотрудник"
        },
        "idp": {
            "search_placeholder": "Найти сотрудников",
            "employee_list": "Список сотрудников",
            "star_tooltip": "Этот сотрудник входит в список <br> резервистов и претендует на <br> повышение в ближайшем будущем",
            "fires_tooltip": "Уволен",
            "employees": "Сотрудники",
            "men": "человек | человек | человека | человек",
            "download": "Скачать",
            "download_report": "Скачать отчёт",
            "individual_development_plan": "Индивидуальный план развития",
            "undefined": "Отсутствует",
            "not_formed": "Не сформирован",
            "on_approval": "На согласовании",
            "on_approval_employee_list": "Нужно согласовать",
            "agreed_by_manager": "Согласован руководителем",
            "agreed_by_hr": "Согласован HR",
            "agreed_by_hr_employee_list": "Согласован",
            "for": "на",
            "send_to_approve_idp": "Отправить на согласование",
            "assign_idp": "Согласовать ИПР",
            "assign_wish": "Согласовать пожелания",
            "assign_all_wishes": "Согласовать все пожелания",
            "assign_not_assigned": "Согласовать несогласованное обучение",
            "add_learning_from_catalog": "Добавить обучение из каталога",
            "mark_learning_as_complete": "Пометить обучение как пройденное",
            "change_learning_status": "Сменить статус обучения",
            "load_files": "Подгрузить файлы",
            "all_years": "Все годы",
            "yr": "г.",
            "filter_event_by_status": "Фильтр по статусам",
            "competencies": "Компетенции",
            "when": "Когда",
            "type": "Тип",
            "add": "Добавить обучение",
            "assign": "Назначить",
            "complete": "Завершить",
            "pending": "На согласовании",
            "approved": "Согласовано HR",
            "assigned": "Назначено",
            "inprogress": "В процессе",
            "assigned_for_wish": "Согласовано",
            "rejected": "Отклонено",
            "canceled": "Отменено",
            "canceled_wish": "Отложено",
            "available": "Доступно в Академии",
            "done": "Пройдено",
            "notdone": "Не пройдено",
            "expired": "Просрочено",
            "mandatory": "Обязательные",
            "addition": "Дополнительные",
            "additional": "Дополнительные",
            "mandatory_security": "Обязательства по безопасности",
            "learnings": "Обучение, которое назначено сотруднику",
            "learnings_employee": "Обучение, которое вам назначено",
            "wishes_txt": "Пожелания сотрудника к обучению",
            "wishes_txt_employee": "Ваши пожелания к обучению",
            "mandatory_tooltip": "В этом блоке размещаются обязательные для прохождения мероприятия, которые добавляет HR. Вы также можете добавить мероприятия из каталога или создать сами по согласованию с HR или руководителем.",
            "additional_tooltip": "В этом блоке размещаются <b><u>необязательные</u></b> для прохождения мероприятия, которые добавляет HR. Вы также можете добавить мероприятия из каталога или создать сами по согласованию с HR или руководителем.",
            "mandatory_security_tooltip": "Мероприятия, курсы и другие развивающие действия, которые необходимы для соответствия требованиям по безопасности труда.",
            "wishes_tooltip": "Другие не приоритетные индивидуальные рекомендации, которые сотрудник может получать в дополнение к основным развивающим действиям.",
            "assign_not_assigned_help": "Выбранный вами статус дет автоматически установлен для всего <br> несогласованного обучения в статусе \"Черновик",
            "learning_tooltip": "Мероприятия, курсы и другие развивающие действия, которые необходимы в приоритетном порядке для достижения поставленных целей, развития и/или укрепления ключевых профессиональных навыков и личностных навыков.",
            "status_tooltip": "Инструкция по согласованию ИПР доступна для скачивания в формате PDF по <a href=\"/\" target=\"_blank\"><b><u>ссылке</u></b> </a> <br> Для того, чтобы согласовать ИПР необходимо согласовать или отклонить все пожелания, добавленные сотрудником",
            "assign_wishes_help": "Выбранный вами статус будет автоматически установлен для всех пожеланий в статусе “На согласовании”. <br>Обратите внимание! Все пожелания будут добавлены в блок “Обучение, которое было добавлено сотруднику”.",
            "wish_tooltip": "Согласованные пожелания передаются в амплуа. В соответствии с ними обучение будет добавлено в каталог или в ИПР сотрудника.",
            "catalog": "Каталог ИПР",
            "course": "Курс в NG Academy",
            "event": "Мероприятие в NG Academy",
            "external": "Вне платформы",
            "individual": "Индивидуальное",
            "wishes": "Пожелание сотрудника",
            "matrix": "Матрица обучения",
            "others": "Прочие",
            "not_found_mandatory": "Обучение еще не добавлено. Проверьте фильтр по статусам",
            "not_found_mandatory_security": "Обязательства по безопасности еще не добавлены или не соответствуют фильтрам по статусу",
            "not_found_addition": "Обучение еще не добавлено. Проверьте фильтр по статусам",
            "not_found_wishes": "Пожелания еще не добавлены или не соответствуют фильтрам по статусу",
            "f_of": "Очный",
            "f_or": "Дистанционный",
            "f_oroli": "Дистанционный (ОЛИМПОКС)",
            "f_ofr": "Очный / дистанционный",
            "m_ow": "На рабочем месте",
            "create_individual": "Создать индивидуальное",
            "create": "Создать",
            "checkout": "Оформить",
            "create_wish": "Оформить пожелание",
            "add_from_catalog": "Выбрать из каталога",
            "cm_view": "Посмотреть",
            "cm_view_edit": "Посмотреть / отредактировать",
            "cm_comment": "Оставить комментарий",
            "cm_reject": "Отклонить",
            "cm_assign": "Согласовать",
            "cm_delete": "Удалить",
            "cm_duplicate": "Дублировать",
            "cm_move_to_mandatory": "В обязательные",
            "cm_move_to_additional": "В дополнительные",
            "cm_move_to_mandatory_security": "В обязательные по безопасности",
            "cm_attach_files": "Прикрепить файлы",
            "cm_mark_as_done": "Пометить как пройденное",
            "cm_attach_new_files": "Приложить новые файлы",
            "cm_set_new_deadline": "Установить новый срок",
            "cm_cancel": "Отменить",
            "cm_cancel_wish": "Отложить",
            "cm_assign_hr": "Назначить",
            "cm_approve": "Согласовать",
            "cm_mark_as_in_process": "Пометить как “В процессе”",
            "cm_mark_as_not_done": "Пометить как не пройденное",
            "comment": "комментариев | комментарий | комментария | комментариев",
            "file": "файлов | файл | файла | файлов",
            "write_comment": "Оставить комментарий",
            "has_expired_activities": "Есть просроченное обучение",
            "has_inconsistent_activities": "Есть несогласованное обучение",
            "has_new_wishes": "Есть новые пожелания",
            "till": "до",
            "employee": "Сотрудник",
            "hr": "HR",
            "manager": "Руководитель",
            "format_at_workplace": "На рабочем месте",
            "format_interaction": "Взаимодействие",
            "format_training": "Тренинг",
            "type_in_person": "Очно",
            "type_online": "Онлайн",
            "type_mix": "Mix",
            "resource_external": "Внешний",
            "resource_internal": "Внутренний",
            "method_mentorship": "Наставничество",
            "method_coaching": "Коучинг",
            "method_internship": "Стажировка",
            "method_self_improvement": "Саморазвитие",
            "method_participation": "Участие в проектах",
            "added_by_you": "Добавлено вами",
            "target_group_hr": "Руководители",
            "target_group_specialists": "Специалисты",
            "target_group_workers": "Рабочие",
            "change_learning_statuses": "Сменить статусы обучения",
            "change_learning_status_help": "Сменить статусы обучения можно только в согласованных ИПР для того обучения, которое не проходится на внешних платформах (Nordgold Academy). <br><br>Обратите внимание, что индивидуальное обучение нужно согласовывать индивидуально для каждого сотрудника!",
            "select_learning_activity": "Выберите обучение из списка ниже",
            "display_only_with_assigned_learning": "В списке сотрудников отображаются только те, кому это обучение было добавлено в ИПР, а также статус этого обучения. Выберите тот, который хотите установить. Некоторые статусы могут быть недоступны.",
            "attach_files_help": "В этом окне вы можете подгрузить файлы (например, сертификаты о прохождении) всем сотрудникам, у которых обучение было добавлено в ИПР в любом статусе. <br>Данная опция доступна только для обучения, которое добавляется из каталога.",
            "display_all_status_learning": "В списке сотрудников отображаются только те, кому данное обучение было добавлено в ИПР в любом статусе.",
            "select_for_all": "Выбрать для всех",
            "empty_wish_list": "Пожелания еще не добавлены или не подходят под установленные фильтры.",
            "empty_learnings_list": "Нет назначений для выбранного периода или выбранных фильтров",
            "learning_for": "Обучение за",
            "y": "г.",
            "you": "Вы",
            "not_found_assignments": "Нет назначений для выбранного периода или выбранных фильтров",
            "per_page": "на странице"
        },
        "catalog": {
            "add_to_idp": "Добавить в ИПР",
            "dont_you_found": "Не нашли программу или мероприятие?",
            "you_can_create_new": "Оформите пожелание или создайте индивидуальное обучение в вашем ИПР",
            "create_event": "Создать мероприятие",
            "view_event": "Просмотр мероприятия",
            "edit_event": "Редактирование мероприятия",
            "import_from_excel": "Импорт из Excel",
            "assign": "Добавить в ИПР",
            "if_not_found_create_new": "Не нашли программу или мероприятие?<br>Создайте пожелание или индивидуальную задачу",
            "assign_as": "как",
            "was_assign_for": "Для ",
            "events_and_programs": "программ / мероприятий или пожеланий",
            "was_assign_users": " уже были назначены сотрудники",
            "assign_search_group": "Найти группу",
            "assign_need_activity": "Необходимо выбрать хотя бы одну позицию",
            "was_assign_show_users": "Просмотреть сотрудников",
            "was_assign_assignments": "Просмотр назначений",
            "assigned_activities": "Мероприятия и программы уже были назначены",
            "assignment_title": "В ИПР у сотрудников:",
            "code": "Код",
            "name": "Название мероприятия",
            "competencies": "Кластер компетенций / группа навыков",
            "source": "Источник",
            "competence": "Кластер компетенций / группа навыков",
            "skills": "Компетенции / навыки",
            "all": "Все",
            "format": "Формат",
            "format_at_workplace": "На рабочем месте",
            "format_webinar": "Онлайн-курс / вебинар",
            "format_offline": "Тренинг / офлайн программа",
            "method_at_workplace": "На рабочем месте",
            "method_internal_training_by_trainer": "Внутренний тренинг тренером БЕ (на БЕ)",
            "method_internal_training_by_external_trainer": "Внутреннее обучение внешним тренером (на БЕ)",
            "method_external_group": "Внешнее групповое обучение (не на БЕ)",
            "method_external_individual": "Внешнее индивидуальное обучение (не на БЕ)",
            "method_probation": "Стажировка на других предприятиях Nordgold",
            "method_webinar": "Онлайн курс / вебинар",
            "author": "Автор",
            "group": "Группа",
            "function": "Функция / должность",
            "type": "Тип",
            "resource": "Ресурс",
            "method": "Метод",
            "trainer_fio": "ФИО тренера / наставника",
            "duration": "Продолжительность, ч",
            "provider": "Провайдер",
            "target_group": "Целевая группа",
            "competence_skill": "Компетенции / навыки",
            "program": "Программа",
            "educational_materials": "Учебные материалы",
            "category": "Категория",
            "employee": "Персонал",
            "when": "Дедлайн",
            "mass_deadline_for_all": "Установите крайний срок прохождения для всех сразу",
            "mass_deadline_for_one": "Установите крайний срок прохождения",
            "mass_deadline_for_every": "Или установите крайний срок прохождения для каждого сотрудника по-отдельности",
            "set_new_deadline": "Установите новый срок прохождения",
            "period": "Период",
            "comment": "Комментарий",
            "link": "Ссылка",
            "link_edit": "Ссылка (если есть)",
            "description": "Описание курса",
            "search_any_way": "Поиск по всему",
            "edit": "Редактировать",
            "view_edit": "Посмотреть / отредактировать ",
            "assign_to_employees": "Назначить сотрудникам",
            "add_as_mandatory": "Добавить в ИПР как обязательное",
            "add_as_additional": "Добавить в ИПР как дополнительное",
            "add_as_security_commitment": "Добавить в ИПР как обязательство по безопасности",
            "view": "Смотреть",
            "cm_view": "Посмотреть",
            "view_assignment": "Смотреть назначения",
            "not_fully_valid": "В карточке не заполнены <br> все необходимые поля",
            "mass_period": "Изменение периода",
            "set_new_period": "Установить период",
            "common_for_all": "Общий для всех обучений",
            "name_placeholder": "Впишите название",
            "add_competence": "Добавить кластер компетенций / группу навыков",
            "add_another_competence": "Добавить еще кластер компетенций / группу навыков",
            "what_to_do": "Что нужно сделать",
            "how_to_develop": "Как я хочу это развить",
            "priority": "Приоритет",
            "additional_info": "Дополнительная информация",
            "additional_info_helper": "Укажите провайдера, ссылку на мероприятие или прочую важную информацию",
            "clear_competence": "Удалить",
            "add_skill": "Добавить навык / компетенцию",
            "add_another_skill": "+Добавить еще компетенцию / навык",
            "add_another_files": "+Добавить еще файлы",
            "choose_competence": "Выберите компетенцию",
            "choose_format_method": "Выберите формат",
            "choose_skill": "Выберите навык / компетенцию",
            "course": "Курс в NG Academy",
            "event": "Мероприятие в NG Academy",
            "external": "Вне платформы",
            "wishes": "Пожелания",
            "start_typing_for_search": "Начните печатать для поиска",
            "no_result_name": "Нет результатов для",
            "template": "Шаблон",
            "create_template": "Создать шаблон",
            "edit_template": "Редактировать шаблон",
            "template_name": "Название шаблона",
            "add_event": "Добавить мероприятие",
            "event_placeholder": "Выберите программу или мероприятие",
            "selected_event": "Выбранные мероприятия",
            "hide_expired": "Скрыть прошедшие",
            "hide_inactive": "Скрыть неактивные",
            "learning": "Обучение \"",
            "learning_already_exists": "\" уже было добавлено в ваш ИПР",
            "learning_already_exists_in_employee": "\" уже было добавлено в ИПР сотрудника",
            "go_to_my_idp": "Перейти в мой ИПР",
            "go_to_employee_idp": "Перейти в ИПР сотрудника",
            "mass_assign_alert_1": "Обучение",
            "mass_assign_alert_2": "уже было назначено выбранным вами сотрудникам",
            "available_by": "доступно по",
            "ekvio_link": "ссылке",
            "employee_type_specialist_manager": "Специалист-менеджер",
            "employee_type_common_employee": "Обычный работник"
        }
    }
}
